import * as React from 'react';

export const DashboardUI = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1095 469"
    fill="none"
    {...props}
  >
    <path fill="#fff" d="M.416.916h1094.08v668.912H.416z" />
    <rect
      width={185.15}
      height={26.025}
      x={18.634}
      y={19.134}
      fill="#fff"
      rx={4.09}
    />
    <rect
      width={185.15}
      height={26.025}
      x={18.634}
      y={19.134}
      stroke="#E9EBED"
      strokeWidth={0.744}
      rx={4.09}
    />
    <path
      stroke="#7E8793"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.115}
      d="M31.99 28.965a2.96 2.96 0 1 1-4.186 4.186 2.96 2.96 0 0 1 4.186-4.186M31.968 33.167l2.9 2.94"
    />
    <path
      fill="#7E8793"
      d="M46.672 35.792c-.652 0-1.225-.142-1.717-.427-.493-.284-.875-.708-1.145-1.27-.271-.569-.406-1.263-.406-2.082s.131-1.513.395-2.082c.27-.569.649-.996 1.135-1.28.493-.292 1.079-.438 1.76-.438.52 0 .985.101 1.394.302.41.195.743.48 1 .854.256.368.42.808.489 1.322h-1.093a1.765 1.765 0 0 0-.323-.802 1.599 1.599 0 0 0-.635-.52 1.837 1.837 0 0 0-.833-.188c-.458 0-.853.101-1.187.302-.326.202-.58.514-.76.937-.18.417-.27.94-.27 1.572 0 .625.093 1.149.28 1.572.188.423.445.74.771.947.326.209.708.313 1.145.313.334 0 .625-.066.875-.198.25-.139.454-.33.614-.573.16-.242.267-.523.323-.843h1.082a3.51 3.51 0 0 1-.5 1.353c-.25.39-.579.691-.988.906-.403.215-.871.323-1.406.323Zm5.168-.146c-.243 0-.438-.031-.584-.093a.624.624 0 0 1-.322-.302 1.283 1.283 0 0 1-.104-.552v-6.34h1.01v6.028c0 .131.024.229.072.291.056.056.15.083.281.083h.635v.885h-.989Zm2.02-5.007h1.009v5.007h-1.01V30.64Zm-.063-2.207h1.124v1.197h-1.124v-1.197Zm4.788 7.36c-.492 0-.926-.111-1.3-.333a2.395 2.395 0 0 1-.865-.937 3.008 3.008 0 0 1-.302-1.364c0-.52.104-.982.313-1.384a2.33 2.33 0 0 1 .895-.937c.381-.23.822-.344 1.322-.344.416 0 .787.077 1.114.23.326.145.586.353.78.624.202.27.32.583.354.937h-1.03a.982.982 0 0 0-.396-.625c-.215-.166-.493-.25-.833-.25a1.391 1.391 0 0 0-1.3.823 2.152 2.152 0 0 0-.178.905c0 .354.063.663.188.927.124.257.294.458.51.604.215.138.468.208.76.208.222 0 .42-.038.593-.115.18-.083.33-.198.448-.343.117-.153.194-.326.229-.52h1.03c-.048.34-.173.655-.375.947a2.106 2.106 0 0 1-.801.687c-.333.173-.718.26-1.156.26Zm4.897-2.394h-.614v-.937h.614l1.686-1.822h1.24l-2.291 2.55v-.614l2.29 3.071H65.19l-1.707-2.248Zm-1.54-5.039h1.009v7.287h-1.01V28.36Zm9.913 7.287c-.291 0-.527-.041-.708-.125a.842.842 0 0 1-.406-.385c-.083-.173-.125-.406-.125-.697v-5.3h1.01v5.102c0 .18.042.312.125.395.083.084.219.125.406.125h1.041v.885h-1.343Zm-2.55-5.007h3.893v.885h-3.893v-.885Zm7.084 5.153c-.507 0-.954-.111-1.343-.333a2.4 2.4 0 0 1-.916-.927c-.215-.402-.323-.867-.323-1.395 0-.52.108-.982.323-1.384a2.31 2.31 0 0 1 .916-.927c.388-.222.836-.333 1.343-.333.506 0 .954.111 1.343.333.388.215.69.524.905.927.222.402.334.864.334 1.384 0 .528-.112.993-.334 1.395a2.31 2.31 0 0 1-.905.937c-.389.215-.837.323-1.343.323Zm0-.916c.305 0 .572-.07.801-.208.236-.146.417-.35.542-.615.132-.263.198-.569.198-.916 0-.34-.066-.642-.198-.905a1.351 1.351 0 0 0-.542-.604 1.461 1.461 0 0 0-.801-.219c-.299 0-.566.073-.802.219-.236.139-.42.34-.552.604a2.092 2.092 0 0 0-.187.905c0 .347.063.653.188.916.131.264.315.469.551.615.236.138.503.208.802.208Zm7.129-5.153c0-.292.052-.538.156-.74.111-.2.27-.353.479-.457a1.55 1.55 0 0 1 .739-.167h1.624v.885H85.1c-.187 0-.333.049-.437.146-.097.097-.146.243-.146.437v5.82h-1v-5.924Zm-1.322.916h4.008v.885h-4.008v-.885Zm5.028 0h1.01v5.007h-1.01V30.64Zm-.063-2.207h1.125v1.197H87.16v-1.197Zm3.706 7.214c-.243 0-.437-.031-.583-.093a.624.624 0 0 1-.323-.302 1.283 1.283 0 0 1-.104-.552v-6.34h1.01v6.028c0 .131.024.229.073.291.055.056.15.083.28.083h.636v.885h-.989Zm3.628 0c-.291 0-.528-.041-.708-.125a.842.842 0 0 1-.406-.385c-.083-.173-.125-.406-.125-.697v-5.3h1.01v5.102c0 .18.042.312.125.395.083.084.218.125.406.125h1.04v.885h-1.342Zm-2.55-5.007h3.893v.885h-3.893v-.885Zm7.02 5.153c-.499 0-.936-.108-1.311-.323a2.281 2.281 0 0 1-.874-.937c-.209-.41-.313-.881-.313-1.415 0-.535.1-1 .302-1.395.208-.396.496-.698.864-.906a2.449 2.449 0 0 1 1.26-.323c.742 0 1.329.226 1.759.677.43.444.646 1.051.646 1.822 0 .069-.004.142-.011.218 0 .077-.007.163-.021.26h-4.32v-.79h3.331V32.627c0-.39-.125-.705-.374-.948-.243-.25-.58-.375-1.01-.375-.292 0-.545.063-.76.188a1.31 1.31 0 0 0-.49.52 1.617 1.617 0 0 0-.176.77v.573c0 .326.059.607.177.843.124.236.298.42.52.552.222.125.49.187.802.187.291 0 .541-.062.75-.187.207-.125.36-.302.457-.531h1.031c-.104.32-.26.6-.469.843a1.965 1.965 0 0 1-.75.541 2.62 2.62 0 0 1-1.02.188Zm3.549-4.154v-1h.895v1.25h-.052c0-.25.042-.468.125-.656a1.03 1.03 0 0 1 .385-.437c.174-.104.385-.156.635-.156h.958v.885h-1.051c-.209 0-.379.038-.511.114a.682.682 0 0 0-.291.344 1.681 1.681 0 0 0-.083.572v3.092h-1.01v-4.008Z"
    />
    <path
      stroke="#7E8793"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.115}
      d="M190.028 29.668v4.957M192.506 32.146h-4.957"
    />
    <path
      stroke="#7E8793"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.115}
      d="M190.028 37.723v0a5.576 5.576 0 0 1-5.577-5.577v0a5.576 5.576 0 0 1 5.577-5.577v0a5.576 5.576 0 0 1 5.576 5.577v0a5.576 5.576 0 0 1-5.576 5.577Z"
      clipRule="evenodd"
    />
    <rect
      width={79.435}
      height={26.025}
      x={901.565}
      y={19.134}
      fill="#fff"
      rx={4.09}
    />
    <rect
      width={79.435}
      height={26.025}
      x={901.565}
      y={19.134}
      stroke="#E9EBED"
      strokeWidth={0.744}
      rx={4.09}
    />
    <path
      fill="#535F6E"
      d="M922.509 27.19c.684 0 1.24.593 1.24 1.327v6.639c0 .732-.556 1.328-1.24 1.328h-9.914c-.684 0-1.239-.596-1.239-1.328v-6.64c0-.732.555-1.327 1.239-1.327h9.914Zm-7.435 1.327h-2.479v6.639h2.479v-6.64Zm1.239 6.639h2.479v-6.64h-2.479v6.64Zm6.196-6.64h-2.478v6.64h2.478v-6.64ZM933.803 35.802c-.659 0-1.238-.139-1.738-.416-.493-.285-.878-.711-1.156-1.28-.277-.57-.416-1.267-.416-2.093 0-.826.135-1.523.406-2.092.278-.576.663-1.007 1.156-1.291.499-.285 1.089-.427 1.769-.427.535 0 1.01.1 1.426.302a2.51 2.51 0 0 1 1.021.864c.263.382.433.843.51 1.384h-1.343a1.652 1.652 0 0 0-.302-.739 1.396 1.396 0 0 0-.562-.458 1.746 1.746 0 0 0-.75-.156c-.409 0-.763.09-1.062.27-.298.174-.53.455-.697.844-.167.389-.25.885-.25 1.489 0 .59.083 1.079.25 1.468.173.388.409.676.708.864.298.18.642.27 1.03.27.299 0 .563-.059.792-.177a1.41 1.41 0 0 0 .551-.5 1.99 1.99 0 0 0 .292-.78h1.332a3.74 3.74 0 0 1-.52 1.415 2.622 2.622 0 0 1-1.01.917c-.416.215-.895.322-1.437.322Zm6.366 0c-.513 0-.971-.11-1.374-.333a2.414 2.414 0 0 1-.937-.947c-.222-.41-.333-.881-.333-1.416 0-.527.111-.996.333-1.405.222-.41.535-.726.937-.948a2.73 2.73 0 0 1 1.374-.343c.521 0 .979.114 1.375.343.402.223.714.538.936.948.229.402.344.87.344 1.405 0 .528-.115.996-.344 1.405-.222.41-.534.73-.936.958-.396.222-.854.333-1.375.333Zm0-1.124c.271 0 .511-.066.719-.198.208-.132.368-.316.479-.551.118-.236.177-.51.177-.823 0-.312-.059-.586-.177-.822a1.284 1.284 0 0 0-.479-.552 1.314 1.314 0 0 0-.719-.198c-.263 0-.499.066-.707.198a1.35 1.35 0 0 0-.49.552c-.111.236-.166.51-.166.822 0 .312.055.587.166.822.118.236.281.42.49.552.208.132.444.198.707.198Zm4.902.968c-.257 0-.465-.035-.624-.104a.698.698 0 0 1-.354-.323c-.077-.145-.115-.34-.115-.583V28.36h1.239v5.85c0 .125.024.216.073.271.055.049.146.073.27.073h.594v1.093h-1.083Zm3.882.156c-.41 0-.767-.083-1.073-.25a1.732 1.732 0 0 1-.687-.739c-.159-.326-.239-.718-.239-1.176v-3.07h1.239v2.945c0 .264.038.483.114.656a.865.865 0 0 0 .333.385c.153.083.337.125.552.125.222 0 .413-.048.573-.146.166-.104.294-.246.385-.426.09-.18.135-.393.135-.636v-2.904h1.239v5.08h-1.093v-1.145l.27.104c-.069.257-.19.476-.364.656-.173.18-.378.316-.614.406a2.14 2.14 0 0 1-.77.135Zm4.012-4.33v-.906h1.093v1l-.208.03c.083-.277.198-.503.343-.676a1.35 1.35 0 0 1 .521-.385c.201-.083.427-.125.676-.125.257 0 .486.049.688.146.208.09.381.222.52.395.146.167.25.368.312.604l-.302.094a2.08 2.08 0 0 1 .406-.698 1.66 1.66 0 0 1 .563-.406 1.78 1.78 0 0 1 .697-.135c.389 0 .722.08.999.24.278.159.49.392.635.697.146.298.219.66.219 1.082v3.217h-1.249v-3.133a1.29 1.29 0 0 0-.094-.531.699.699 0 0 0-.281-.333.864.864 0 0 0-.458-.115.84.84 0 0 0-.458.125.86.86 0 0 0-.312.354c-.077.153-.115.33-.115.531v3.102h-1.239v-3.133c0-.215-.031-.392-.093-.531a.704.704 0 0 0-.281-.333.864.864 0 0 0-.458-.115.82.82 0 0 0-.458.136.87.87 0 0 0-.313.353 1.153 1.153 0 0 0-.114.521v3.102h-1.239v-4.174Zm8.55 0v-.906h1.093v1.02l-.188.073a1.42 1.42 0 0 1 .313-.676c.166-.188.367-.33.603-.427.243-.098.507-.146.791-.146.417 0 .774.087 1.073.26.305.167.538.413.697.74.167.319.25.707.25 1.165v3.071h-1.239V32.7c0-.264-.041-.479-.125-.645a.781.781 0 0 0-.343-.386 1.088 1.088 0 0 0-.562-.135c-.222 0-.42.052-.594.156a1.042 1.042 0 0 0-.395.417c-.091.18-.136.392-.136.635v2.904h-1.238v-4.174Zm7.88 4.33c-.458 0-.857-.062-1.197-.187a1.724 1.724 0 0 1-.781-.552 1.605 1.605 0 0 1-.291-.895h1.28a.628.628 0 0 0 .146.354c.083.097.198.17.344.218.152.042.333.063.541.063.187 0 .347-.024.479-.073a.715.715 0 0 0 .312-.218.513.513 0 0 0 .115-.323.418.418 0 0 0-.084-.27.463.463 0 0 0-.229-.178 1.377 1.377 0 0 0-.385-.083l-.812-.083a2.082 2.082 0 0 1-.822-.25 1.417 1.417 0 0 1-.531-.52 1.522 1.522 0 0 1-.188-.76c0-.334.084-.622.25-.865.174-.243.417-.43.729-.562.319-.139.694-.208 1.124-.208.424 0 .795.062 1.114.187.319.118.566.299.739.542.181.236.281.527.302.874h-1.239a.496.496 0 0 0-.125-.323.651.651 0 0 0-.322-.197 1.484 1.484 0 0 0-.49-.073c-.263 0-.475.048-.635.145a.467.467 0 0 0-.229.417.48.48 0 0 0 .073.26c.056.07.139.129.25.177.111.042.253.073.427.094l.822.093c.32.042.59.129.812.26.229.133.403.306.521.521.118.215.177.462.177.74 0 .34-.09.638-.271.895-.173.25-.427.444-.76.583a3.156 3.156 0 0 1-1.166.197Z"
    />
    <rect
      width={87.102}
      height={26.025}
      x={989.18}
      y={19.134}
      fill="#fff"
      rx={4.09}
    />
    <rect
      width={87.102}
      height={26.025}
      x={989.18}
      y={19.134}
      stroke="#E9EBED"
      strokeWidth={0.744}
      rx={4.09}
    />
    <path
      fill="#535F6E"
      d="M998.757 28.36h4.613v1.196h-3.739l.409-.395v5.684l-.409-.396h3.739v1.197h-4.613V28.36Zm.739 2.862h3.874v1.197h-3.874v-1.197Zm6.754 1.51v.603l-2.02-2.769h1.5l1.3 1.884h-.4l1.3-1.884h1.5l-2.02 2.77v-.605l2.12 2.915h-1.5l-1.42-1.957h.42l-1.4 1.957h-1.5l2.12-2.915Zm4.05-1.26v-.906h1.1v1.166l-.17-.229c.07-.222.2-.413.37-.573.18-.166.4-.294.65-.385.26-.09.53-.135.82-.135.48 0 .9.114 1.27.343.37.223.65.538.85.948.21.402.32.87.32 1.405s-.11 1.006-.32 1.416c-.2.402-.48.718-.85.947a2.41 2.41 0 0 1-1.27.333c-.28 0-.53-.041-.77-.125a1.52 1.52 0 0 1-.6-.343c-.16-.16-.28-.347-.35-.562l.19-.24v2.988h-1.24v-6.048Zm2.57 3.206c.27 0 .5-.066.7-.198.21-.132.37-.316.48-.551.12-.236.18-.51.18-.823 0-.312-.06-.586-.18-.822-.11-.236-.27-.42-.48-.552-.2-.132-.43-.198-.7-.198-.27 0-.5.066-.7.198-.21.132-.37.316-.48.552-.11.236-.17.51-.17.822 0 .312.06.587.17.822.11.236.27.42.48.552.2.132.43.198.7.198Zm6.15 1.124c-.52 0-.97-.11-1.38-.333-.4-.229-.71-.545-.93-.947-.23-.41-.34-.881-.34-1.416 0-.527.11-.996.34-1.405.22-.41.53-.726.93-.948.41-.229.86-.343 1.38-.343.52 0 .98.114 1.37.343.4.223.72.538.94.948.23.402.34.87.34 1.405 0 .528-.11.996-.34 1.405-.22.41-.54.73-.94.958-.39.222-.85.333-1.37.333Zm0-1.124c.27 0 .51-.066.72-.198.2-.132.36-.316.48-.551.11-.236.17-.51.17-.823 0-.312-.06-.586-.17-.822a1.41 1.41 0 0 0-.48-.552 1.325 1.325 0 0 0-.72-.198c-.27 0-.5.066-.71.198-.21.132-.37.316-.49.552-.11.236-.17.51-.17.822 0 .312.06.587.17.822.12.236.28.42.49.552.21.132.44.198.71.198Zm3.82-3.206v-.906h1.09v1.29h-.04c0-.27.04-.499.13-.686a.988.988 0 0 1 .41-.448c.18-.104.4-.156.66-.156h.93v1.093h-1.07c-.2 0-.37.035-.5.104a.661.661 0 0 0-.28.312c-.06.14-.09.316-.09.531v3.04h-1.24v-4.174Zm6.29 4.174c-.3 0-.55-.041-.75-.125a.886.886 0 0 1-.41-.416c-.09-.188-.14-.437-.14-.75v-5.278h1.24v4.997c0 .167.04.288.12.365.07.076.19.114.36.114h1.07v1.093h-1.49Zm-2.6-5.08h4.09v1.093h-4.09v-1.093Zm9.67 5.08c-.31 0-.56-.041-.75-.125a.863.863 0 0 1-.42-.416c-.09-.188-.13-.437-.13-.75v-5.278h1.24v4.997c0 .167.04.288.11.365.08.076.2.114.37.114h1.07v1.093h-1.49Zm-2.6-5.08h4.09v1.093h-4.09v-1.093Zm7.32 5.236c-.52 0-.98-.11-1.38-.333a2.49 2.49 0 0 1-.94-.947c-.22-.41-.33-.881-.33-1.416 0-.527.11-.996.33-1.405.23-.41.54-.726.94-.948.4-.229.86-.343 1.38-.343.52 0 .97.114 1.37.343.4.223.71.538.94.948.23.402.34.87.34 1.405 0 .528-.11.996-.34 1.405-.23.41-.54.73-.94.958-.4.222-.85.333-1.37.333Zm0-1.124c.27 0 .51-.066.71-.198.21-.132.37-.316.48-.551.12-.236.18-.51.18-.823 0-.312-.06-.586-.18-.822-.11-.236-.27-.42-.48-.552-.2-.132-.44-.198-.71-.198-.27 0-.5.066-.71.198-.21.132-.37.316-.49.552-.11.236-.17.51-.17.822 0 .312.06.587.17.822.12.236.28.42.49.552.21.132.44.198.71.198Zm9.57 1.124c-.66 0-1.24-.139-1.74-.416-.49-.285-.88-.711-1.15-1.28-.28-.57-.42-1.267-.42-2.093 0-.826.14-1.523.41-2.092.27-.576.66-1.007 1.15-1.291.5-.285 1.09-.427 1.77-.427.54 0 1.01.1 1.43.302.41.194.75.482 1.02.864.26.382.43.843.51 1.384h-1.35a1.487 1.487 0 0 0-.3-.739 1.345 1.345 0 0 0-.56-.458 1.733 1.733 0 0 0-.75-.156c-.41 0-.76.09-1.06.27-.3.174-.53.455-.7.844-.16.389-.25.885-.25 1.489 0 .59.09 1.079.25 1.468.18.388.41.676.71.864.3.18.64.27 1.03.27.3 0 .56-.059.79-.177.23-.118.41-.284.55-.5.15-.222.25-.482.29-.78h1.34a3.86 3.86 0 0 1-.52 1.415c-.26.396-.6.701-1.01.917-.42.215-.9.322-1.44.322Zm6.81 0c-.61 0-1.14-.093-1.58-.28-.45-.195-.79-.473-1.02-.834-.24-.367-.36-.801-.37-1.3h1.31c.01.256.08.482.21.676.13.187.33.333.58.437.25.104.54.156.87.156.29 0 .54-.045.76-.135.22-.09.39-.222.51-.396.12-.173.18-.374.18-.603a.826.826 0 0 0-.13-.48.782.782 0 0 0-.37-.332 2.077 2.077 0 0 0-.64-.177l-.89-.125c-.48-.063-.88-.18-1.21-.354-.32-.18-.56-.41-.72-.687a2.114 2.114 0 0 1-.23-1c0-.437.11-.819.34-1.145.22-.326.53-.576.93-.75.4-.18.87-.27 1.41-.27.55 0 1.03.087 1.44.26.41.167.73.41.94.729.22.32.34.697.34 1.135h-1.3a.816.816 0 0 0-.19-.531 1.12 1.12 0 0 0-.49-.344 2.013 2.013 0 0 0-.74-.125c-.27 0-.5.038-.71.115a.986.986 0 0 0-.48.343.812.812 0 0 0-.17.5c0 .18.05.333.13.458.09.118.22.219.41.302.18.076.4.132.68.166l.85.115c.47.063.86.18 1.17.354.31.174.55.41.71.708.16.291.24.642.24 1.051 0 .48-.11.895-.33 1.25-.23.353-.55.627-.97.822-.42.194-.91.291-1.47.291Zm3.33-7.443h1.43l2.18 6.506h-.41l2.17-6.506h1.44l-2.53 7.287h-1.76l-2.52-7.287Z"
    />
    <g clipPath="url(#a)">
      <g filter="url(#b)">
        <path fill="#fff" d="M18.262 57.428h23.794v41.64H18.262z" />
        <g clipPath="url(#c)">
          <rect
            width={11.154}
            height={11.154}
            x={30.531}
            y={72.671}
            stroke="#BABDC1"
            strokeWidth={0.744}
            rx={2.603}
          />
        </g>
      </g>
      <g filter="url(#d)">
        <path fill="#fff" d="M18.262 99.068h23.794v56.838H18.262z" />
        <g clipPath="url(#e)">
          <rect
            width={11.154}
            height={11.154}
            x={30.531}
            y={121.91}
            stroke="#BABDC1"
            strokeWidth={0.744}
            rx={2.603}
          />
        </g>
      </g>
      <g filter="url(#f)">
        <path fill="#fff" d="M18.262 155.906h23.794v56.838H18.262z" />
        <g clipPath="url(#g)">
          <rect
            width={11.154}
            height={11.154}
            x={30.531}
            y={178.748}
            stroke="#BABDC1"
            strokeWidth={0.744}
            rx={2.603}
          />
        </g>
      </g>
      <g filter="url(#h)">
        <path fill="#fff" d="M18.262 212.744h23.794v56.838H18.262z" />
        <g clipPath="url(#i)">
          <rect
            width={11.154}
            height={11.154}
            x={30.531}
            y={235.587}
            stroke="#BABDC1"
            strokeWidth={0.744}
            rx={2.603}
          />
        </g>
      </g>
      <g filter="url(#j)">
        <path fill="#fff" d="M18.262 269.582h23.794v56.838H18.262z" />
        <g clipPath="url(#k)">
          <rect
            width={11.154}
            height={11.154}
            x={30.531}
            y={292.425}
            stroke="#BABDC1"
            strokeWidth={0.744}
            rx={2.603}
          />
        </g>
      </g>
      <g filter="url(#l)">
        <path fill="#fff" d="M18.262 326.421h23.794v56.838H18.262z" />
        <g clipPath="url(#m)">
          <rect
            width={11.154}
            height={11.154}
            x={30.531}
            y={349.263}
            stroke="#BABDC1"
            strokeWidth={0.744}
            rx={2.603}
          />
        </g>
      </g>
      <g filter="url(#n)">
        <path fill="#fff" d="M18.262 383.259h23.794v56.838H18.262z" />
        <g clipPath="url(#o)">
          <rect
            width={11.154}
            height={11.154}
            x={30.531}
            y={406.101}
            stroke="#BABDC1"
            strokeWidth={0.744}
            rx={2.603}
          />
        </g>
      </g>
      <g filter="url(#p)">
        <path fill="#fff" d="M42.056 57.428h171.022v41.64H42.056z" />
        <path
          fill="#535F6E"
          d="M54.73 75.745h1.32l2.775 4.846-.187.053v-4.899h1.098v6.246h-1.321l-2.784-4.845.196-.053v4.898H54.73v-6.246Zm8.65 0h1.508l2.302 6.246h-1.204l-2.026-5.8h.348l-2.043 5.8h-1.196l2.311-6.246Zm-.874 3.543h3.239v1h-3.24v-1Zm6.021-3.543h1.535l1.856 5.22h-.304l1.865-5.22h1.535v6.246h-1.07v-5.255l.187.018-1.874 5.237h-.982l-1.865-5.237.179-.018v5.255h-1.062v-6.246Zm8.49 0h3.952v1.026h-3.203l.348-.339v4.872l-.348-.339h3.203v1.026h-3.953v-6.246Zm.633 2.454h3.319v1.026h-3.32V78.2Z"
        />
      </g>
      <g filter="url(#q)">
        <path fill="#fff" d="M42.056 99.068h171.022v56.838H42.056z" />
        <g clipPath="url(#r)">
          <rect
            width={94.307}
            height={11.788}
            x={50.979}
            y={121.593}
            fill="#F4F4F5"
            rx={5.894}
          />
        </g>
      </g>
      <g filter="url(#s)">
        <path fill="#fff" d="M42.056 155.906h171.022v56.838H42.056z" />
        <g clipPath="url(#t)">
          <g clipPath="url(#u)">
            <path
              fill="#1C2938"
              d="M56.545 180.439h5.624v1.459h-4.558l.495-.482v6.932l-.495-.483h4.558v1.46h-5.624v-8.886Zm.901 3.491h4.723v1.46h-4.723v-1.46Zm6.31.304v-1.104h1.333v1.219l-.254.038c.102-.339.242-.614.42-.825a1.63 1.63 0 0 1 .634-.47c.246-.102.52-.153.825-.153.313 0 .593.06.838.178.254.11.466.271.635.483.178.203.305.448.38.736l-.367.114c.126-.347.292-.63.495-.85.203-.22.431-.385.685-.496.263-.11.546-.165.85-.165.475 0 .881.098 1.22.292.338.195.596.479.774.851.178.364.267.804.267 1.32v3.923h-1.524v-3.821c0-.262-.038-.478-.114-.648a.859.859 0 0 0-.343-.406 1.053 1.053 0 0 0-.559-.139c-.211 0-.397.05-.558.152-.16.101-.288.245-.38.432-.094.186-.14.402-.14.647v3.783h-1.511v-3.821a1.59 1.59 0 0 0-.115-.648.858.858 0 0 0-.342-.406 1.053 1.053 0 0 0-.559-.139 1.05 1.05 0 0 0-.94.596 1.4 1.4 0 0 0-.139.635v3.783h-1.51v-5.091Zm12.305 5.282c-.474 0-.889-.081-1.245-.242a1.923 1.923 0 0 1-.825-.672 1.919 1.919 0 0 1-.279-1.041c0-.39.085-.728.254-1.016.17-.296.423-.529.762-.698.338-.178.753-.284 1.244-.318l2.183-.127v1.13l-1.955.165a1.212 1.212 0 0 0-.546.14.853.853 0 0 0-.33.292.711.711 0 0 0-.101.381c0 .152.038.287.114.406a.772.772 0 0 0 .355.267c.161.059.352.088.572.088.28 0 .525-.05.736-.152.22-.101.39-.254.508-.457.127-.212.19-.461.19-.749v-1.79c0-.22-.038-.398-.114-.533a.71.71 0 0 0-.343-.305c-.152-.068-.35-.101-.596-.101s-.445.025-.597.076a.65.65 0 0 0-.356.228.9.9 0 0 0-.177.407h-1.498c.042-.432.169-.792.38-1.08.212-.287.513-.503.902-.647.39-.152.872-.229 1.447-.229.5 0 .927.085 1.282.254.356.161.627.398.813.711.195.313.292.69.292 1.13v2.882a.19.19 0 0 0 .05.14c.034.033.081.05.14.05h.546v1.219h-1.142a.897.897 0 0 1-.381-.076.57.57 0 0 1-.241-.229.783.783 0 0 1-.077-.355v-.889l.229.165a1.454 1.454 0 0 1-.33.826 1.962 1.962 0 0 1-.775.558 2.953 2.953 0 0 1-1.091.191Zm5.002-6.386h1.511v6.195h-1.51v-6.195Zm-.05-2.628h1.625v1.549h-1.625v-1.549Zm4.755 8.823c-.313 0-.567-.042-.761-.127a.854.854 0 0 1-.432-.393c-.093-.178-.14-.415-.14-.711v-7.655h1.511v7.134c0 .153.03.263.09.33.067.06.177.089.33.089h.723v1.333h-1.32Zm9.518.191c-.796 0-1.503-.178-2.12-.534-.61-.355-1.084-.88-1.422-1.574-.339-.702-.508-1.544-.508-2.526 0-.982.17-1.82.508-2.514.338-.702.812-1.231 1.422-1.587.617-.355 1.324-.533 2.12-.533.804 0 1.51.178 2.12.533.61.356 1.083.885 1.422 1.587.338.694.507 1.532.507 2.514 0 .982-.169 1.824-.507 2.526-.339.694-.813 1.219-1.422 1.574-.61.356-1.316.534-2.12.534Zm0-1.46c.482 0 .905-.115 1.27-.343.372-.237.66-.593.862-1.067.204-.482.305-1.07.305-1.764s-.101-1.278-.305-1.752c-.203-.483-.49-.838-.863-1.067a2.282 2.282 0 0 0-1.27-.355c-.482 0-.905.119-1.269.355-.364.229-.652.584-.863 1.067-.203.474-.305 1.058-.305 1.752s.102 1.282.305 1.764c.211.474.5.83.863 1.067.364.228.787.343 1.27.343Zm5.651-3.822v-1.104h1.333v1.422l-.203-.28c.093-.27.245-.503.457-.698.22-.203.482-.359.787-.47.313-.11.647-.165 1.003-.165.584 0 1.1.14 1.549.419.448.271.795.656 1.041 1.156.253.491.38 1.062.38 1.714 0 .651-.127 1.227-.38 1.726a2.815 2.815 0 0 1-1.041 1.155c-.449.271-.965.407-1.549.407-.339 0-.652-.051-.94-.153a1.976 1.976 0 0 1-.736-.419 1.686 1.686 0 0 1-.419-.685l.229-.292v3.643h-1.511v-7.376Zm3.136 3.91c.321 0 .605-.08.85-.241.254-.161.449-.385.584-.673a2.21 2.21 0 0 0 .216-1.002c0-.381-.072-.716-.216-1.003a1.561 1.561 0 0 0-.584-.673 1.514 1.514 0 0 0-.85-.241c-.331 0-.618.08-.864.241-.245.161-.44.385-.584.673a2.335 2.335 0 0 0-.203 1.003c0 .38.068.715.203 1.002.144.288.339.512.584.673.246.161.533.241.864.241Zm6.874 1.181c-.373 0-.677-.051-.914-.152a1.058 1.058 0 0 1-.508-.508c-.11-.229-.165-.533-.165-.914v-6.437h1.511v6.094c0 .203.046.351.139.444.093.094.242.14.445.14h1.307v1.333h-1.815Zm-3.174-6.195h4.989v1.333h-4.989v-1.333Zm13.25 6.386c-.795 0-1.502-.178-2.12-.534-.609-.355-1.083-.88-1.422-1.574-.338-.702-.508-1.544-.508-2.526 0-.982.17-1.82.508-2.514.339-.702.813-1.231 1.422-1.587.618-.355 1.325-.533 2.12-.533.804 0 1.511.178 2.12.533.61.356 1.084.885 1.422 1.587.339.694.508 1.532.508 2.514 0 .982-.169 1.824-.508 2.526-.338.694-.812 1.219-1.422 1.574-.609.356-1.316.534-2.12.534Zm0-1.46c.483 0 .906-.115 1.27-.343.372-.237.66-.593.863-1.067.203-.482.305-1.07.305-1.764s-.102-1.278-.305-1.752c-.203-.483-.491-.838-.863-1.067a2.282 2.282 0 0 0-1.27-.355c-.482 0-.905.119-1.269.355-.364.229-.652.584-.864 1.067-.203.474-.304 1.058-.304 1.752s.101 1.282.304 1.764c.212.474.5.83.864 1.067a2.34 2.34 0 0 0 1.269.343Zm7.949 1.46c-.5 0-.935-.102-1.308-.305a2.112 2.112 0 0 1-.838-.901c-.194-.398-.292-.876-.292-1.435v-3.745h1.511v3.593c0 .321.047.588.14.799.093.204.228.36.406.47.186.102.41.152.673.152.271 0 .503-.059.698-.177.203-.127.36-.301.47-.521.11-.22.165-.478.165-.774v-3.542h1.511v6.195h-1.333v-1.396l.33.127a1.814 1.814 0 0 1-.445.799c-.211.22-.461.385-.749.496-.287.11-.601.165-.939.165Zm7.365-.191c-.372 0-.677-.051-.914-.152a1.062 1.062 0 0 1-.508-.508c-.11-.229-.165-.533-.165-.914v-6.437h1.511v6.094c0 .203.047.351.14.444.093.094.241.14.444.14h1.308v1.333h-1.816Zm-3.174-6.195h4.99v1.333h-4.99v-1.333Z"
            />
          </g>
        </g>
      </g>
      <g filter="url(#v)">
        <path fill="#fff" d="M42.056 212.744h171.022v56.838H42.056z" />
        <g clipPath="url(#w)">
          <rect
            width={94.307}
            height={11.788}
            x={50.979}
            y={235.269}
            fill="#F4F4F5"
            rx={5.894}
          />
        </g>
      </g>
      <g filter="url(#x)">
        <path fill="#fff" d="M42.056 269.582h171.022v56.838H42.056z" />
        <g clipPath="url(#y)">
          <rect
            width={94.307}
            height={11.788}
            x={50.979}
            y={292.107}
            fill="#F4F4F5"
            rx={5.894}
          />
        </g>
      </g>
      <g filter="url(#z)">
        <path fill="#fff" d="M42.056 326.421h171.022v56.838H42.056z" />
        <g clipPath="url(#A)">
          <rect
            width={94.307}
            height={11.788}
            x={50.979}
            y={348.945}
            fill="#F4F4F5"
            rx={5.894}
          />
        </g>
      </g>
      <g filter="url(#B)">
        <path fill="#fff" d="M42.056 383.259h171.022v56.838H42.056z" />
        <g clipPath="url(#C)">
          <rect
            width={94.307}
            height={11.788}
            x={50.979}
            y={405.784}
            fill="#F4F4F5"
            rx={5.894}
          />
        </g>
      </g>
      <g filter="url(#D)">
        <path fill="#fff" d="M213.078 57.428H384.1v41.64H213.078z" />
        <path
          fill="#535F6E"
          d="M225.752 75.745h2.65c.434 0 .809.078 1.124.232.322.155.568.375.741.66.172.286.259.625.259 1.018 0 .392-.087.734-.259 1.026a1.705 1.705 0 0 1-.741.66c-.315.155-.69.232-1.124.232h-2.052v-1.026h2.007c.221 0 .408-.035.563-.107a.808.808 0 0 0 .365-.303.902.902 0 0 0 .125-.482.856.856 0 0 0-.125-.473.808.808 0 0 0-.365-.303 1.337 1.337 0 0 0-.563-.108h-1.855l.348-.339v5.56h-1.098v-6.247Zm8.683 6.38c-.5 0-.934-.098-1.303-.294a2.08 2.08 0 0 1-.838-.857c-.191-.375-.286-.818-.286-1.33v-3.899h1.098v3.82c0 .326.05.606.151.838.107.226.259.399.455.518.203.119.444.178.723.178.28 0 .518-.06.714-.178.202-.12.354-.292.455-.518.107-.232.161-.512.161-.839v-3.819h1.106v3.9c0 .511-.098.954-.294 1.33-.191.368-.47.654-.839.856-.363.196-.797.294-1.303.294Zm4.339-6.38h2.739c.434 0 .809.075 1.124.223.322.15.569.363.741.643.173.28.259.613.259 1 0 .386-.086.719-.259.999-.172.28-.419.496-.741.651-.315.149-.69.223-1.124.223l-.33-.027h-1.811v-1h2.141c.214 0 .396-.032.544-.097a.775.775 0 0 0 .348-.295.842.842 0 0 0 .116-.455.797.797 0 0 0-.116-.446.724.724 0 0 0-.348-.285 1.247 1.247 0 0 0-.544-.108h-1.99l.348-.339v5.56h-1.097v-6.247Zm1.668 3.534 1.062-.366 2.311 3.078h-1.356l-2.017-2.712Zm4.939-3.534h2.65c.434 0 .809.078 1.124.232.321.155.568.375.741.66.172.286.258.625.258 1.018 0 .392-.086.734-.258 1.026a1.71 1.71 0 0 1-.741.66c-.315.155-.69.232-1.124.232h-2.053v-1.026h2.008c.22 0 .408-.035.562-.107a.805.805 0 0 0 .366-.303.91.91 0 0 0 .125-.482.865.865 0 0 0-.125-.473.805.805 0 0 0-.366-.303 1.332 1.332 0 0 0-.562-.108h-1.856l.348-.339v5.56h-1.097v-6.247Zm8.879 6.38c-.559 0-1.056-.125-1.49-.374-.428-.25-.761-.62-.999-1.107-.238-.494-.357-1.086-.357-1.776s.119-1.279.357-1.766c.238-.494.571-.866.999-1.116.434-.25.931-.374 1.49-.374.565 0 1.062.124 1.49.374.429.25.762.622 1 1.116.238.487.357 1.076.357 1.766s-.119 1.282-.357 1.776c-.238.488-.571.857-1 1.106-.428.25-.925.375-1.49.375Zm0-1.026c.339 0 .637-.08.893-.24.261-.167.464-.417.606-.75.143-.34.214-.753.214-1.24 0-.488-.071-.899-.214-1.232-.142-.34-.345-.589-.606-.75a1.601 1.601 0 0 0-.893-.25c-.339 0-.636.084-.892.25-.256.161-.458.41-.607.75-.143.333-.214.744-.214 1.231 0 .488.071.902.214 1.24.149.334.351.584.607.75.256.16.553.241.892.241Zm6.658 1.026c-.524 0-.976-.08-1.356-.24a1.94 1.94 0 0 1-.875-.715c-.202-.315-.306-.687-.312-1.115h1.124c.006.22.066.414.179.58.113.16.276.286.49.375.214.09.464.134.75.134.25 0 .467-.039.651-.116a.934.934 0 0 0 .437-.34.892.892 0 0 0 .152-.517.756.756 0 0 0-.107-.41.689.689 0 0 0-.321-.286 1.752 1.752 0 0 0-.544-.152l-.768-.107c-.41-.053-.755-.154-1.035-.303a1.59 1.59 0 0 1-.616-.589 1.795 1.795 0 0 1-.196-.856c0-.375.095-.703.286-.982.19-.28.458-.494.803-.642.345-.155.746-.232 1.204-.232.476 0 .89.074 1.241.223.351.142.618.35.803.624.19.274.288.598.294.973h-1.115a.715.715 0 0 0-.17-.455.911.911 0 0 0-.419-.295 1.706 1.706 0 0 0-.634-.107 1.75 1.75 0 0 0-.606.098.852.852 0 0 0-.411.295.69.69 0 0 0-.143.428c0 .155.036.286.107.393a.914.914 0 0 0 .348.258c.155.066.351.114.589.143l.723.098c.405.054.741.155 1.008.304.268.148.47.35.607.606.137.25.205.55.205.902 0 .41-.095.767-.285 1.07a1.872 1.872 0 0 1-.83.705c-.357.167-.776.25-1.258.25Zm4.039-6.38h3.953v1.026h-3.204l.348-.339v4.872l-.348-.339h3.204v1.026h-3.953v-6.246Zm.634 2.454h3.319v1.026h-3.319V78.2Z"
        />
        <path
          stroke="#7E8793"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.115}
          d="M278.155 82.152v0a3.904 3.904 0 0 1-3.904-3.904v0a3.904 3.904 0 0 1 3.904-3.904v0a3.904 3.904 0 0 1 3.904 3.904v0a3.904 3.904 0 0 1-3.904 3.904Z"
          clipRule="evenodd"
        />
        <path
          stroke="#7E8793"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.115}
          d="M278.155 80.417v-2.17h-.434M278.046 76.513a.108.108 0 0 0-.108.108.109.109 0 1 0 .108-.108"
        />
      </g>
      <g filter="url(#E)">
        <path fill="#fff" d="M213.078 99.068H384.1v56.838H213.078z" />
        <g clipPath="url(#F)">
          <g clipPath="url(#G)">
            <path fill="#F9F9F9" d="M222.001 116.572h45.358v21.83h-45.358z" />
            <path fill="#F4F4F5" d="M267.359 116.572h33.461v21.83h-33.461z" />
          </g>
        </g>
      </g>
      <g filter="url(#H)">
        <path fill="#fff" d="M213.078 155.906H384.1v56.838H213.078z" />
        <g clipPath="url(#I)">
          <g clipPath="url(#J)">
            <path fill="#BFBDFC" d="M222.001 173.41h109.923v21.83H222.001z" />
            <path
              fill="#fff"
              d="M227.41 181.208h3.231c.53 0 .987.094 1.371.283.392.189.693.457.904.805.21.348.315.762.315 1.241 0 .478-.105.896-.315 1.251a2.08 2.08 0 0 1-.904.805c-.384.189-.841.283-1.371.283h-2.502v-1.251h2.448c.268 0 .497-.044.686-.131a.99.99 0 0 0 .446-.37 1.11 1.11 0 0 0 .152-.587c0-.225-.051-.417-.152-.577a.99.99 0 0 0-.446-.37 1.633 1.633 0 0 0-.686-.131h-2.263l.424-.413v6.779h-1.338v-7.617Zm6.85 3.254v-.947h1.143v1.349h-.044c0-.283.047-.522.142-.718a1.02 1.02 0 0 1 .424-.468 1.35 1.35 0 0 1 .686-.163h.979v1.142h-1.121c-.21 0-.384.037-.522.109a.681.681 0 0 0-.294.327c-.065.145-.098.33-.098.555v3.177h-1.295v-4.363Zm6.401 4.526a2.921 2.921 0 0 1-1.436-.348 2.515 2.515 0 0 1-.98-.99c-.232-.428-.348-.921-.348-1.48 0-.551.116-1.041.348-1.469.232-.428.559-.758.98-.99.42-.24.899-.359 1.436-.359.544 0 1.023.119 1.436.359.421.232.748.562.98.99.239.421.359.91.359 1.469 0 .551-.12 1.041-.359 1.469a2.498 2.498 0 0 1-.98 1.001c-.413.232-.892.348-1.436.348Zm0-1.175c.283 0 .533-.069.751-.207a1.34 1.34 0 0 0 .5-.576c.124-.247.185-.534.185-.86 0-.326-.061-.613-.185-.86a1.34 1.34 0 0 0-.5-.576 1.373 1.373 0 0 0-.751-.207c-.276 0-.522.069-.74.207-.218.137-.388.33-.511.576a2.004 2.004 0 0 0-.174.86c0 .326.058.613.174.86.123.246.293.439.511.576.218.138.464.207.74.207Zm6.233 1.175c-.501 0-.947-.116-1.339-.348a2.404 2.404 0 0 1-.892-.99c-.21-.428-.316-.921-.316-1.48 0-.559.106-1.048.316-1.469a2.32 2.32 0 0 1 .892-.99 2.51 2.51 0 0 1 1.339-.359c.283 0 .547.043.794.13.247.08.453.203.62.37.174.16.298.352.37.577l-.196.261v-3.482h1.295v7.617h-1.142v-1.219l.174.24a1.47 1.47 0 0 1-.403.609 1.923 1.923 0 0 1-.664.392 2.486 2.486 0 0 1-.848.141Zm.206-1.175c.276 0 .519-.069.73-.207.21-.137.373-.33.489-.576.124-.247.185-.534.185-.86 0-.326-.061-.613-.185-.86a1.364 1.364 0 0 0-.489-.576 1.303 1.303 0 0 0-.73-.207 1.37 1.37 0 0 0-.75.207 1.36 1.36 0 0 0-.49.576 2.004 2.004 0 0 0-.174.86c0 .326.058.613.174.86.116.246.279.439.49.576.217.138.468.207.75.207Zm6.228 1.175c-.428 0-.802-.087-1.121-.261a1.8 1.8 0 0 1-.718-.772c-.167-.341-.251-.751-.251-1.23v-3.21h1.295v3.079c0 .276.04.505.12.686a.91.91 0 0 0 .348.403c.16.087.352.13.577.13.232 0 .431-.051.598-.152.174-.109.309-.258.403-.446.094-.189.141-.41.141-.664v-3.036h1.295V188.825h-1.142v-1.197l.283.109a1.57 1.57 0 0 1-.381.686c-.182.188-.396.33-.642.424a2.244 2.244 0 0 1-.805.141Zm6.5 0c-.537 0-1.004-.119-1.403-.359a2.533 2.533 0 0 1-.915-1.001 3.217 3.217 0 0 1-.315-1.436c0-.552.112-1.041.337-1.469a2.47 2.47 0 0 1 .947-1.001c.413-.247.885-.37 1.415-.37.457 0 .859.083 1.207.25.356.16.639.388.849.686.218.297.345.642.381 1.033h-1.317a.973.973 0 0 0-.37-.566c-.195-.152-.449-.228-.761-.228a1.25 1.25 0 0 0-.719.207c-.203.13-.359.322-.467.576a2.114 2.114 0 0 0-.164.86c0 .334.055.624.164.871.116.246.272.438.467.576.204.131.439.196.708.196.203 0 .384-.036.544-.109.167-.079.301-.188.402-.326.109-.138.182-.294.218-.468h1.317a2.39 2.39 0 0 1-.403 1.034c-.21.312-.497.566-.859.761-.363.189-.784.283-1.263.283Zm5.604-.163c-.319 0-.58-.043-.783-.13a.914.914 0 0 1-.436-.436c-.094-.196-.141-.457-.141-.783v-5.517h1.295v5.223c0 .174.04.301.12.381.079.08.206.12.38.12h1.121v1.142h-1.556Zm-2.72-5.31h4.276v1.142h-4.276v-1.142Zm8.256-2.307h1.61l3.384 5.909-.228.065v-5.974h1.338v7.617h-1.61l-3.395-5.909.239-.065v5.974h-1.338v-7.617Zm10.093 7.78c-.537 0-1.008-.116-1.415-.348a2.42 2.42 0 0 1-.925-1.001c-.217-.428-.326-.929-.326-1.502 0-.558.109-1.048.326-1.469.218-.42.523-.743.914-.968a2.658 2.658 0 0 1 1.361-.348c.805 0 1.436.243 1.893.729.464.486.696 1.146.696 1.98 0 .08-.003.167-.01.261 0 .095-.004.193-.011.294h-4.571v-1.001h3.287v-.033c0-.355-.113-.642-.338-.859-.225-.218-.54-.327-.946-.327-.276 0-.515.055-.719.164a1.136 1.136 0 0 0-.457.467 1.55 1.55 0 0 0-.152.697v.74c0 .297.054.555.163.772.109.218.269.385.479.501.21.109.464.163.762.163.268 0 .493-.054.674-.163.189-.116.33-.268.425-.457h1.327a2.636 2.636 0 0 1-.489.914c-.218.254-.49.45-.816.588a2.909 2.909 0 0 1-1.132.206Zm3.045-5.473h1.349l1.175 4.396h-.283l1.175-4.396h1.491l1.175 4.396h-.283l1.176-4.396h1.349l-1.589 5.31h-1.534l-1.186-4.418h.305l-1.197 4.418h-1.535l-1.588-5.31Zm11.195 5.473c-.479 0-.896-.065-1.251-.196a1.793 1.793 0 0 1-.816-.576 1.667 1.667 0 0 1-.305-.936h1.338a.66.66 0 0 0 .153.37.781.781 0 0 0 .359.228c.159.044.348.066.566.066.196 0 .362-.026.5-.076a.76.76 0 0 0 .327-.229.538.538 0 0 0 .119-.337.439.439 0 0 0-.087-.283.476.476 0 0 0-.239-.185 1.412 1.412 0 0 0-.403-.087l-.848-.087a2.201 2.201 0 0 1-.86-.261 1.482 1.482 0 0 1-.555-.545 1.585 1.585 0 0 1-.196-.794c0-.348.087-.649.261-.903.182-.254.435-.45.762-.588.334-.145.725-.217 1.175-.217.443 0 .831.065 1.164.196a1.6 1.6 0 0 1 .773.565c.189.247.294.552.316.914h-1.295a.526.526 0 0 0-.131-.337.693.693 0 0 0-.337-.207 1.573 1.573 0 0 0-.512-.076c-.275 0-.497.051-.663.153a.485.485 0 0 0-.24.435c0 .101.026.192.076.272a.675.675 0 0 0 .262.185c.116.043.264.076.446.098l.859.098c.334.043.617.134.849.272a1.4 1.4 0 0 1 .544.544c.123.225.185.482.185.772 0 .356-.094.668-.283.936-.181.261-.446.465-.794.61a3.318 3.318 0 0 1-1.219.206Zm4.584-.163c-.269 0-.486-.036-.653-.109a.731.731 0 0 1-.37-.337c-.08-.152-.12-.355-.12-.609v-6.562h1.295v6.115c0 .131.025.225.076.283.058.051.152.077.283.077h.62v1.142h-1.131Zm4.363.163c-.537 0-1.008-.116-1.415-.348a2.42 2.42 0 0 1-.925-1.001c-.217-.428-.326-.929-.326-1.502 0-.558.109-1.048.326-1.469a2.32 2.32 0 0 1 .915-.968 2.655 2.655 0 0 1 1.36-.348c.805 0 1.436.243 1.893.729.464.486.697 1.146.697 1.98 0 .08-.004.167-.011.261 0 .095-.004.193-.011.294h-4.57v-1.001h3.286v-.033c0-.355-.113-.642-.338-.859-.224-.218-.54-.327-.946-.327-.276 0-.515.055-.718.164a1.124 1.124 0 0 0-.457.467 1.537 1.537 0 0 0-.153.697v.74c0 .297.055.555.163.772.109.218.269.385.479.501.211.109.464.163.762.163.268 0 .493-.054.675-.163.188-.116.33-.268.424-.457h1.327a2.636 2.636 0 0 1-.489.914c-.218.254-.49.45-.816.588a2.909 2.909 0 0 1-1.132.206Zm5.678-.163c-.32 0-.581-.043-.784-.13a.908.908 0 0 1-.435-.436c-.094-.196-.142-.457-.142-.783v-5.517h1.295v5.223c0 .174.04.301.12.381.08.08.207.12.381.12h1.121v1.142h-1.556Zm-2.721-5.31h4.277v1.142h-4.277v-1.142Zm7.534 5.31c-.319 0-.58-.043-.783-.13a.908.908 0 0 1-.435-.436c-.095-.196-.142-.457-.142-.783v-5.517h1.295v5.223c0 .174.04.301.12.381.08.08.207.12.381.12h1.12v1.142h-1.556Zm-2.72-5.31h4.276v1.142h-4.276v-1.142Zm7.584 5.473c-.536 0-1.008-.116-1.414-.348a2.413 2.413 0 0 1-.925-1.001c-.218-.428-.327-.929-.327-1.502 0-.558.109-1.048.327-1.469.217-.42.522-.743.914-.968a2.655 2.655 0 0 1 1.36-.348c.805 0 1.436.243 1.893.729.465.486.697 1.146.697 1.98 0 .08-.004.167-.011.261 0 .095-.004.193-.011.294h-4.57v-1.001h3.286v-.033c0-.355-.112-.642-.337-.859-.225-.218-.541-.327-.947-.327-.276 0-.515.055-.718.164a1.13 1.13 0 0 0-.457.467 1.536 1.536 0 0 0-.152.697v.74c0 .297.054.555.163.772.109.218.268.385.479.501.21.109.464.163.761.163.269 0 .494-.054.675-.163.189-.116.33-.268.424-.457h1.328a2.638 2.638 0 0 1-.49.914c-.217.254-.489.45-.816.588a2.905 2.905 0 0 1-1.132.206Zm3.718-4.526v-.947h1.143v1.349h-.044c0-.283.047-.522.142-.718a1.02 1.02 0 0 1 .424-.468 1.35 1.35 0 0 1 .686-.163h.979v1.142h-1.121c-.21 0-.384.037-.522.109a.681.681 0 0 0-.294.327c-.065.145-.098.33-.098.555v3.177h-1.295v-4.363Z"
            />
            <path fill="#7F7CF9" d="M331.924 173.41h31.923v21.83h-31.923z" />
            <path
              fill="#fff"
              d="M338.921 182.285h1.339v6.54h-1.339v-6.54Zm-2.35-1.077h6.039v1.251h-6.039v-1.251Zm6.22 3.254v-.947h1.143v1.349h-.044c0-.283.047-.522.141-.718.095-.203.236-.359.425-.468.188-.109.417-.163.685-.163h.98v1.142H345c-.21 0-.385.037-.522.109a.681.681 0 0 0-.294.327c-.066.145-.098.33-.098.555v3.177h-1.295v-4.363Zm6.231 4.526c-.429 0-.802-.087-1.121-.261a1.8 1.8 0 0 1-.718-.772c-.167-.341-.251-.751-.251-1.23v-3.21h1.295v3.079c0 .276.04.505.12.686a.91.91 0 0 0 .348.403c.16.087.352.13.577.13.232 0 .431-.051.598-.152.174-.109.309-.258.403-.446.094-.189.141-.41.141-.664v-3.036h1.295V188.825h-1.142v-1.197l.283.109a1.57 1.57 0 0 1-.381.686c-.182.188-.396.33-.642.424a2.244 2.244 0 0 1-.805.141Zm6.533 0c-.537 0-1.008-.116-1.415-.348a2.42 2.42 0 0 1-.925-1.001c-.217-.428-.326-.929-.326-1.502 0-.558.109-1.048.326-1.469.218-.42.523-.743.914-.968a2.658 2.658 0 0 1 1.361-.348c.805 0 1.436.243 1.893.729.464.486.696 1.146.696 1.98 0 .08-.003.167-.01.261 0 .095-.004.193-.011.294h-4.571v-1.001h3.287v-.033c0-.355-.113-.642-.338-.859-.225-.218-.54-.327-.946-.327-.276 0-.515.055-.719.164a1.136 1.136 0 0 0-.457.467 1.55 1.55 0 0 0-.152.697v.74c0 .297.054.555.163.772.109.218.269.385.479.501.21.109.464.163.762.163.268 0 .493-.054.674-.163.189-.116.33-.268.425-.457h1.327a2.636 2.636 0 0 1-.489.914c-.218.254-.49.45-.816.588a2.909 2.909 0 0 1-1.132.206Z"
            />
          </g>
        </g>
      </g>
      <g filter="url(#K)">
        <path fill="#fff" d="M213.078 212.744H384.1v56.838H213.078z" />
        <g clipPath="url(#L)">
          <g clipPath="url(#M)">
            <path fill="#F9F9F9" d="M222.001 230.248h45.358v21.83h-45.358z" />
            <path fill="#F4F4F5" d="M267.359 230.248h33.461v21.83h-33.461z" />
          </g>
        </g>
      </g>
      <g filter="url(#N)">
        <path fill="#fff" d="M213.078 269.582H384.1v56.838H213.078z" />
        <g clipPath="url(#O)">
          <g clipPath="url(#P)">
            <path fill="#F9F9F9" d="M222.001 287.086h45.358v21.83h-45.358z" />
            <path fill="#F4F4F5" d="M267.359 287.086h33.461v21.83h-33.461z" />
          </g>
        </g>
      </g>
      <g filter="url(#Q)">
        <path fill="#fff" d="M213.078 326.421H384.1v56.838H213.078z" />
        <g clipPath="url(#R)">
          <g clipPath="url(#S)">
            <path fill="#F9F9F9" d="M222.001 343.925h45.358v21.83h-45.358z" />
            <path fill="#F4F4F5" d="M267.359 343.925h33.461v21.83h-33.461z" />
          </g>
        </g>
      </g>
      <g filter="url(#T)">
        <path fill="#fff" d="M213.078 383.259H384.1v56.838H213.078z" />
        <g clipPath="url(#U)">
          <g clipPath="url(#V)">
            <path fill="#F9F9F9" d="M222.001 400.763h45.358v21.83h-45.358z" />
            <path fill="#F4F4F5" d="M267.359 400.763h33.461v21.83h-33.461z" />
          </g>
        </g>
      </g>
      <g filter="url(#W)">
        <path fill="#fff" d="M384.101 57.428H637.66v41.64H384.101z" />
        <path
          fill="#535F6E"
          d="M399.308 82.125c-.565 0-1.061-.119-1.49-.357-.422-.244-.752-.61-.99-1.097-.238-.488-.357-1.086-.357-1.794s.116-1.305.348-1.793c.238-.494.568-.863.99-1.107.429-.243.934-.365 1.517-.365.458 0 .866.086 1.223.258.357.167.648.414.874.74.226.328.372.724.437 1.188h-1.151a1.406 1.406 0 0 0-.259-.634 1.188 1.188 0 0 0-.481-.392 1.5 1.5 0 0 0-.643-.134c-.351 0-.654.077-.91.232-.256.148-.455.39-.598.722-.143.334-.214.759-.214 1.276 0 .506.071.925.214 1.258.149.334.351.58.607.741.256.155.55.232.883.232.256 0 .482-.05.678-.152a1.21 1.21 0 0 0 .473-.428c.125-.19.209-.413.25-.67h1.142a3.208 3.208 0 0 1-.446 1.214c-.22.34-.508.601-.865.786a2.648 2.648 0 0 1-1.232.276Zm6.651 0c-.559 0-1.056-.125-1.49-.374-.429-.25-.762-.62-1-1.107-.238-.494-.356-1.086-.356-1.776s.118-1.279.356-1.766c.238-.494.571-.866 1-1.116.434-.25.931-.374 1.49-.374.565 0 1.062.124 1.49.374.428.25.761.622.999 1.116.238.487.357 1.076.357 1.766s-.119 1.282-.357 1.776c-.238.488-.571.857-.999 1.106-.428.25-.925.375-1.49.375Zm0-1.026c.339 0 .636-.08.892-.24.262-.167.464-.417.607-.75.143-.34.214-.753.214-1.24 0-.488-.071-.899-.214-1.232-.143-.34-.345-.589-.607-.75a1.598 1.598 0 0 0-.892-.25c-.339 0-.637.084-.892.25-.256.161-.458.41-.607.75-.143.333-.214.744-.214 1.231 0 .488.071.902.214 1.24.149.334.351.584.607.75.255.16.553.241.892.241Zm4.552-5.354h1.32l2.775 4.846-.187.053v-4.899h1.097v6.246h-1.32l-2.784-4.845.196-.053v4.898h-1.097v-6.246Zm6.999 0h1.32l2.775 4.846-.187.053v-4.899h1.097v6.246h-1.32l-2.784-4.845.196-.053v4.898h-1.097v-6.246Zm6.998 0h3.953v1.026h-3.203l.348-.339v4.872l-.348-.339h3.203v1.026h-3.953v-6.246Zm.634 2.454h3.319v1.026h-3.319V78.2Zm7.601 3.926c-.565 0-1.062-.119-1.49-.357-.422-.244-.753-.61-.99-1.097-.238-.488-.357-1.086-.357-1.794s.116-1.305.348-1.793c.238-.494.568-.863.99-1.107.428-.243.934-.365 1.517-.365.458 0 .865.086 1.222.258.357.167.649.414.875.74.226.328.372.724.437 1.188h-1.151a1.417 1.417 0 0 0-.259-.634 1.191 1.191 0 0 0-.482-.392 1.493 1.493 0 0 0-.642-.134c-.351 0-.654.077-.91.232-.256.148-.455.39-.598.722-.143.334-.214.759-.214 1.276 0 .506.071.925.214 1.258.149.334.351.58.607.741.256.155.55.232.883.232.256 0 .482-.05.678-.152a1.21 1.21 0 0 0 .473-.428c.125-.19.208-.413.25-.67h1.142a3.208 3.208 0 0 1-.446 1.214c-.22.34-.509.601-.866.786a2.64 2.64 0 0 1-1.231.276Zm5.358-5.496h1.098v5.362h-1.098V76.63Zm-1.927-.884h4.952v1.026h-4.952v-1.026Zm6.316 0h3.953v1.026h-3.203l.348-.339v4.872l-.348-.339h3.203v1.026h-3.953v-6.246Zm.634 2.454h3.319v1.026h-3.319V78.2Zm5.11-2.454h2.258c.601 0 1.118.128 1.552.384.441.25.777.61 1.009 1.08.238.464.357 1.017.357 1.66 0 .642-.119 1.198-.357 1.668a2.524 2.524 0 0 1-1.009 1.08c-.434.25-.951.374-1.552.374h-2.258v-6.246Zm.75 5.238h1.57c.369 0 .681-.086.937-.259.262-.178.458-.425.589-.74.131-.316.196-.687.196-1.116 0-.428-.065-.8-.196-1.115a1.57 1.57 0 0 0-.589-.732c-.256-.178-.568-.267-.937-.267h-1.57l.348-.34v4.908l-.348-.339Zm8.813-5.238h1.097v6.246h-1.097v-6.246Zm3.095 0h1.32l2.776 4.846-.188.053v-4.899h1.098v6.246h-1.321l-2.784-4.845.196-.053v4.898h-1.097v-6.246Zm8.293.884h1.097v5.362h-1.097V76.63Zm-1.928-.884h4.953v1.026h-4.953v-1.026Zm6.317 0h3.953v1.026h-3.204l.348-.339v4.872l-.348-.339h3.204v1.026h-3.953v-6.246Zm.633 2.454h3.32v1.026h-3.32V78.2Zm7.521 3.926c-.541 0-1.02-.128-1.436-.383-.417-.256-.741-.628-.973-1.116-.232-.488-.348-1.07-.348-1.749 0-.672.116-1.255.348-1.749.232-.493.562-.868.991-1.124.428-.262.933-.392 1.516-.392.476 0 .896.083 1.259.25.362.16.654.398.874.713.226.316.366.693.419 1.133h-1.142a1.303 1.303 0 0 0-.25-.57 1.155 1.155 0 0 0-.481-.375 1.628 1.628 0 0 0-.679-.134 1.65 1.65 0 0 0-.928.258c-.255.167-.452.42-.588.759-.137.339-.206.752-.206 1.24 0 .494.069.907.206 1.24.142.328.348.575.615.741.268.16.589.241.964.241.285 0 .535-.056.749-.17.221-.112.39-.282.509-.508a1.82 1.82 0 0 0 .178-.839l.322.259h-2.338v-1h3.069v3.141h-.91v-1.32l.223.053a1.481 1.481 0 0 1-.348.723c-.178.214-.407.38-.687.5a2.303 2.303 0 0 1-.928.178Zm4.467-6.38h2.739c.435 0 .809.075 1.125.223.321.15.568.363.74.643.173.28.259.613.259 1 0 .386-.086.719-.259.999a1.72 1.72 0 0 1-.74.651c-.316.149-.69.223-1.125.223l-.33-.027h-1.811v-1h2.141c.214 0 .396-.032.545-.097a.786.786 0 0 0 .348-.295.851.851 0 0 0 .116-.455.805.805 0 0 0-.116-.446.734.734 0 0 0-.348-.285 1.255 1.255 0 0 0-.545-.108h-1.99l.348-.339v5.56h-1.097v-6.247Zm1.669 3.534 1.061-.366 2.311 3.078h-1.356l-2.016-2.712Zm6.624-3.534h1.508l2.302 6.246h-1.204l-2.026-5.8h.348l-2.043 5.8h-1.196l2.311-6.246Zm-.874 3.543h3.239v1h-3.239v-1Zm6.714-2.66h1.097v5.363h-1.097V76.63Zm-1.927-.883h4.952v1.026h-4.952v-1.026Zm6.316 0h1.097v6.246h-1.097v-6.246Zm5.638 6.38c-.559 0-1.056-.125-1.49-.374-.428-.25-.761-.62-.999-1.107-.238-.494-.357-1.086-.357-1.776s.119-1.279.357-1.766c.238-.494.571-.866.999-1.116.434-.25.931-.374 1.49-.374.565 0 1.062.124 1.49.374.429.25.762.622 1 1.116.238.487.357 1.076.357 1.766s-.119 1.282-.357 1.776c-.238.488-.571.857-1 1.106-.428.25-.925.375-1.49.375Zm0-1.026c.339 0 .637-.08.892-.24.262-.167.464-.417.607-.75.143-.34.214-.753.214-1.24 0-.488-.071-.899-.214-1.232-.143-.34-.345-.589-.607-.75a1.595 1.595 0 0 0-.892-.25c-.339 0-.636.084-.892.25-.256.161-.458.41-.607.75-.143.333-.214.744-.214 1.231 0 .488.071.902.214 1.24.149.334.351.584.607.75.256.16.553.241.892.241Zm4.552-5.354h1.32l2.775 4.846-.187.053v-4.899h1.098v6.246h-1.321l-2.784-4.845.196-.053v4.898h-1.097v-6.246Zm9.105 6.38c-.524 0-.976-.08-1.357-.24a1.942 1.942 0 0 1-.874-.715 2.07 2.07 0 0 1-.312-1.115h1.124c.006.22.065.414.178.58.113.16.277.286.491.375.214.09.464.134.75.134.249 0 .466-.039.651-.116a.939.939 0 0 0 .437-.34.9.9 0 0 0 .152-.517.756.756 0 0 0-.107-.41.698.698 0 0 0-.321-.286 1.759 1.759 0 0 0-.545-.152l-.767-.107c-.411-.053-.756-.154-1.035-.303a1.59 1.59 0 0 1-.616-.589 1.784 1.784 0 0 1-.196-.856c0-.375.095-.703.285-.982.191-.28.458-.494.803-.642.345-.155.747-.232 1.205-.232.476 0 .889.074 1.24.223.351.142.619.35.803.624.191.274.289.598.295.973h-1.116a.714.714 0 0 0-.169-.455.911.911 0 0 0-.419-.295 1.706 1.706 0 0 0-.634-.107 1.76 1.76 0 0 0-.607.098.854.854 0 0 0-.41.295.69.69 0 0 0-.143.428c0 .155.036.286.107.393a.899.899 0 0 0 .348.258c.155.066.351.114.589.143l.723.098c.404.054.74.155 1.008.304.268.148.47.35.607.606.137.25.205.55.205.902 0 .41-.095.767-.286 1.07-.19.304-.466.539-.829.705-.357.167-.777.25-1.258.25Z"
        />
      </g>
      <g filter="url(#X)">
        <path fill="#fff" d="M384.101 99.068H637.66v56.838H384.101z" />
        <rect
          width={237.944}
          height={26.769}
          x={393.024}
          y={114.103}
          fill="#F9F9F9"
          rx={4.461}
        />
        <path
          stroke="#DDDDE0"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.115}
          d="m619.814 126-2.974 2.974-2.975-2.974"
        />
      </g>
      <g filter="url(#Y)">
        <path fill="#fff" d="M384.101 155.906H637.66v56.838H384.101z" />
        <rect
          width={237.2}
          height={30.013}
          x={393.395}
          y={169.319}
          fill="#fff"
          rx={4.09}
        />
        <rect
          width={237.2}
          height={30.013}
          x={393.395}
          y={169.319}
          stroke="#DDDDE0"
          strokeWidth={0.744}
          rx={4.09}
        />
        <rect
          width={84.111}
          height={21.833}
          x={398.229}
          y={173.408}
          fill="#F8F9FB"
          rx={3.639}
        />
        <path
          fill="#00A1E0"
          d="M407.923 180.095a2.564 2.564 0 0 1 1.846-.791c.963 0 1.797.535 2.246 1.332a3.139 3.139 0 0 1 1.268-.268c1.733 0 3.14 1.418 3.14 3.167 0 1.749-1.407 3.167-3.14 3.167-.214 0-.417-.022-.62-.064a2.297 2.297 0 0 1-3.007.946 2.614 2.614 0 0 1-4.862-.117 2.549 2.549 0 0 1-.498.053c-1.342 0-2.428-1.102-2.428-2.455 0-.909.486-1.701 1.214-2.129a2.789 2.789 0 0 1-.23-1.124 2.826 2.826 0 0 1 5.071-1.717Z"
        />
        <path
          fill="#fff"
          d="M403.97 184.273c-.011.022.005.027.005.032.027.022.054.032.086.049.15.08.289.101.433.101.3 0 .487-.16.487-.412v-.005c0-.235-.209-.321-.407-.385l-.026-.011c-.15-.048-.279-.091-.279-.187v-.006c0-.085.075-.144.193-.144.128 0 .284.043.38.096 0 0 .027.016.037-.01l.059-.166c.006-.016-.005-.027-.016-.032a.828.828 0 0 0-.428-.113h-.032c-.273 0-.465.166-.465.402v.005c0 .251.208.332.406.385l.032.011c.145.043.268.08.268.182v.005c0 .091-.08.161-.209.161-.048 0-.208 0-.385-.113-.021-.011-.032-.021-.048-.032-.011-.005-.032-.016-.038.016l-.053.171ZM408.346 184.273c-.011.022.005.027.005.032.027.022.053.032.086.049a.87.87 0 0 0 .433.101c.299 0 .487-.16.487-.412v-.005c0-.235-.209-.321-.407-.385l-.027-.011c-.149-.048-.278-.091-.278-.187v-.006c0-.085.075-.144.193-.144.128 0 .283.043.38.096 0 0 .026.016.037-.01l.059-.166c.005-.016-.005-.027-.016-.032a.83.83 0 0 0-.428-.113h-.032c-.273 0-.466.166-.466.402v.005c0 .251.209.332.407.385l.032.011c.144.043.268.08.268.182v.005c0 .091-.081.161-.209.161-.048 0-.209 0-.385-.113-.022-.011-.032-.021-.048-.032-.006-.005-.032-.011-.038.016l-.053.171ZM411.577 183.503a.672.672 0 0 0-.113-.214.591.591 0 0 0-.46-.198.59.59 0 0 0-.46.198.584.584 0 0 0-.112.214.841.841 0 0 0-.037.267c0 .097.01.188.037.268a.69.69 0 0 0 .112.214.572.572 0 0 0 .193.144.682.682 0 0 0 .267.054.591.591 0 0 0 .46-.198.586.586 0 0 0 .113-.214.873.873 0 0 0 .037-.268.87.87 0 0 0-.037-.267Zm-.246.267a.597.597 0 0 1-.081.337c-.053.081-.133.118-.24.118-.113 0-.188-.037-.241-.118a.598.598 0 0 1-.08-.337c0-.144.026-.256.08-.337.053-.08.128-.117.241-.117.112 0 .192.037.24.117a.602.602 0 0 1 .081.337Z"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M413.626 184.188c-.011-.027-.033-.016-.033-.016a.439.439 0 0 1-.117.032c-.043.005-.086.01-.139.01a.38.38 0 0 1-.284-.107c-.069-.069-.107-.187-.107-.342 0-.139.032-.246.096-.326.059-.08.156-.123.279-.123a.79.79 0 0 1 .262.037s.021.011.026-.016c.022-.059.038-.101.059-.171.006-.021-.01-.027-.016-.027a1.668 1.668 0 0 0-.166-.043c-.053-.01-.117-.01-.187-.01a.65.65 0 0 0-.278.053.583.583 0 0 0-.326.359.84.84 0 0 0-.043.267c0 .209.053.375.166.498.112.123.278.187.492.187.128 0 .257-.027.353-.064 0 0 .016-.011.011-.032l-.048-.166ZM414.899 183.455a.576.576 0 0 0-.107-.198.456.456 0 0 0-.161-.123.568.568 0 0 0-.24-.048.64.64 0 0 0-.279.053.5.5 0 0 0-.192.15.539.539 0 0 0-.113.219.904.904 0 0 0-.037.268.87.87 0 0 0 .037.267.534.534 0 0 0 .337.353.876.876 0 0 0 .305.048c.246 0 .375-.053.423-.085.011-.005.016-.016.005-.043l-.053-.155c-.011-.021-.032-.016-.032-.016-.059.021-.145.064-.348.064-.128 0-.23-.037-.289-.102-.064-.064-.091-.155-.096-.278h.845s.021 0 .027-.021c-.006 0 .021-.161-.032-.353Zm-.84.176a.447.447 0 0 1 .069-.198.268.268 0 0 1 .241-.123.26.26 0 0 1 .236.123.391.391 0 0 1 .053.198h-.599ZM408.142 183.455a.544.544 0 0 0-.107-.198.453.453 0 0 0-.16-.123.573.573 0 0 0-.241-.048.636.636 0 0 0-.278.053.51.51 0 0 0-.193.15.55.55 0 0 0-.112.219.873.873 0 0 0-.037.268c0 .096.01.187.037.267a.532.532 0 0 0 .337.353.872.872 0 0 0 .305.048c.246 0 .375-.053.423-.085.01-.005.016-.016.005-.043l-.053-.155c-.011-.021-.033-.016-.033-.016-.058.021-.144.064-.347.064-.129 0-.23-.037-.289-.102-.064-.064-.091-.155-.096-.278h.845s.021 0 .027-.021c-.006 0 .021-.161-.033-.353Zm-.839.176a.435.435 0 0 1 .069-.198.267.267 0 0 1 .241-.123c.112 0 .182.043.235.123a.463.463 0 0 1 .054.198h-.599Z"
          clipRule="evenodd"
        />
        <path
          fill="#fff"
          d="M405.815 183.588c-.032 0-.08-.005-.133-.005a.86.86 0 0 0-.209.027.53.53 0 0 0-.176.08.44.44 0 0 0-.123.139.371.371 0 0 0-.043.193c0 .075.01.139.037.192a.374.374 0 0 0 .113.134.555.555 0 0 0 .171.075 1.386 1.386 0 0 0 .481 0c.08-.016.182-.032.214-.043.027-.005.059-.016.059-.016.021-.005.021-.027.021-.027v-.77c0-.171-.042-.294-.133-.374a.593.593 0 0 0-.386-.118 1.62 1.62 0 0 0-.224.021s-.182.038-.262.097c0 0-.016.01-.006.032l.059.16c.006.022.027.016.027.016s.005 0 .016-.005c.16-.086.369-.086.369-.086.091 0 .161.016.209.054.048.037.069.091.069.203v.038c-.085-.006-.15-.017-.15-.017Zm-.337.594a.188.188 0 0 1-.048-.048.218.218 0 0 1-.026-.112c0-.075.026-.129.074-.166 0 0 .075-.064.247-.059.123 0 .23.022.23.022v.385s-.107.021-.23.032c-.172.005-.247-.054-.247-.054Z"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M412.62 183.155c.005-.021-.006-.027-.011-.032a.598.598 0 0 0-.139-.021.394.394 0 0 0-.219.037.367.367 0 0 0-.145.107v-.101c0-.017-.01-.027-.026-.027h-.214c-.016 0-.027.01-.027.027v1.257c0 .016.011.026.027.026h.219c.016 0 .027-.01.027-.026v-.632c0-.085.01-.171.026-.219a.258.258 0 0 1 .075-.123.234.234 0 0 1 .102-.064.42.42 0 0 1 .203-.005.036.036 0 0 0 .032-.022 1.7 1.7 0 0 0 .07-.182ZM410.539 182.572a.373.373 0 0 0-.086-.021.598.598 0 0 0-.112-.011.482.482 0 0 0-.358.128c-.086.086-.139.214-.172.386l-.01.058h-.193s-.021 0-.027.027l-.032.177c0 .016.006.026.027.026h.187l-.187 1.054a2.116 2.116 0 0 1-.048.209.358.358 0 0 1-.059.118.158.158 0 0 1-.075.058.282.282 0 0 1-.101.016c-.022 0-.049-.005-.07-.005-.021-.005-.032-.011-.048-.016 0 0-.022-.011-.032.016l-.064.171c-.006.016 0 .032.01.032a.558.558 0 0 0 .198.032.6.6 0 0 0 .209-.032.374.374 0 0 0 .155-.107.536.536 0 0 0 .107-.187c.027-.075.053-.171.075-.283l.192-1.076h.279s.021 0 .026-.026l.032-.177c0-.016-.005-.027-.026-.027h-.268c0-.005.016-.101.043-.192a.215.215 0 0 1 .059-.091.139.139 0 0 1 .069-.043c.027-.011.059-.011.091-.011.027 0 .048.006.07.006.027.005.037.01.043.01.026.011.032 0 .037-.01l.064-.177c.016-.021 0-.027-.005-.032ZM406.768 184.396a.026.026 0 0 1-.027.027h-.225a.026.026 0 0 1-.027-.027v-1.797c0-.016.011-.027.027-.027h.225c.016 0 .027.011.027.027v1.797Z"
          clipRule="evenodd"
        />
        <path
          fill="#1C2938"
          d="M425.408 188.989c-.641 0-1.194-.098-1.66-.295-.465-.204-.822-.495-1.07-.873-.247-.386-.374-.841-.382-1.365h1.376a1.3 1.3 0 0 0 .218.71c.139.196.339.349.601.458.262.109.567.164.917.164.305 0 .571-.047.797-.142.232-.095.411-.233.534-.415.124-.182.186-.393.186-.633a.924.924 0 0 0-.131-.502.842.842 0 0 0-.393-.349 2.114 2.114 0 0 0-.666-.186l-.939-.131c-.502-.066-.924-.189-1.266-.371a1.941 1.941 0 0 1-.753-.721 2.182 2.182 0 0 1-.24-1.048c0-.458.116-.858.349-1.201.233-.342.56-.604.982-.786.423-.189.914-.283 1.474-.283.582 0 1.088.091 1.518.273.429.174.756.429.982.764.233.334.353.731.36 1.19h-1.364a.877.877 0 0 0-.208-.557 1.106 1.106 0 0 0-.513-.36 2.065 2.065 0 0 0-.775-.131c-.276 0-.524.04-.742.12-.219.08-.386.2-.502.36a.838.838 0 0 0-.175.524c0 .189.044.349.131.48.095.124.237.23.426.317.189.08.429.138.72.175l.884.12c.495.065.907.189 1.234.371.328.182.575.429.742.742.168.306.252.673.252 1.103 0 .502-.117.939-.35 1.31-.233.371-.571.658-1.015.862-.437.204-.95.306-1.539.306Zm5.762 0a2.56 2.56 0 0 1-1.07-.208 1.658 1.658 0 0 1-.71-.578 1.648 1.648 0 0 1-.24-.895 1.7 1.7 0 0 1 .218-.874c.146-.254.364-.455.655-.6.291-.153.648-.244 1.07-.273l1.878-.109v.971l-1.681.142a1.062 1.062 0 0 0-.47.12.76.76 0 0 0-.284.251.616.616 0 0 0-.087.328c0 .131.033.247.098.349a.66.66 0 0 0 .306.23c.138.051.302.076.491.076.24 0 .452-.044.633-.131a.95.95 0 0 0 .437-.393 1.23 1.23 0 0 0 .164-.644v-1.539a.939.939 0 0 0-.098-.459.616.616 0 0 0-.295-.262 1.28 1.28 0 0 0-.513-.087c-.211 0-.382.022-.513.065a.565.565 0 0 0-.306.197.77.77 0 0 0-.153.349h-1.288c.036-.371.146-.68.328-.928.181-.247.44-.433.775-.557.334-.131.749-.196 1.244-.196.43 0 .797.073 1.103.218.305.139.538.342.698.612.168.269.251.593.251.971v2.478c0 .051.015.091.044.12.029.03.069.044.12.044h.47v1.048h-.983a.779.779 0 0 1-.327-.065.493.493 0 0 1-.208-.197.683.683 0 0 1-.065-.306v-.764l.196.142a1.25 1.25 0 0 1-.284.71 1.679 1.679 0 0 1-.666.48 2.538 2.538 0 0 1-.938.164Zm5.448-.164c-.27 0-.488-.036-.655-.109a.733.733 0 0 1-.371-.339c-.08-.152-.12-.356-.12-.611v-6.583h1.299v6.136c0 .131.025.225.076.283.058.051.153.077.284.077h.622v1.146h-1.135Zm4.377.164c-.538 0-1.011-.117-1.419-.35-.4-.24-.709-.574-.928-1.004-.218-.429-.327-.931-.327-1.506 0-.561.109-1.052.327-1.474.219-.422.524-.746.917-.972.4-.233.855-.349 1.365-.349.808 0 1.441.244 1.899.731.466.488.699 1.15.699 1.987 0 .08-.004.168-.011.262 0 .095-.004.193-.011.295h-4.585v-1.004h3.297v-.033c0-.357-.113-.644-.338-.863-.226-.218-.543-.327-.95-.327-.277 0-.517.055-.721.164a1.138 1.138 0 0 0-.458.469 1.542 1.542 0 0 0-.153.699v.742c0 .299.055.557.164.775.109.219.269.386.48.502.211.11.466.164.764.164.269 0 .495-.054.677-.164.189-.116.331-.269.426-.458h1.332c-.11.349-.273.655-.492.917a2.164 2.164 0 0 1-.818.589 2.889 2.889 0 0 1-1.136.208Zm5.641 0c-.481 0-.899-.066-1.256-.197a1.813 1.813 0 0 1-.819-.578 1.677 1.677 0 0 1-.305-.939h1.342a.662.662 0 0 0 .153.371.795.795 0 0 0 .361.229c.16.044.349.066.567.066.197 0 .364-.026.502-.077a.75.75 0 0 0 .328-.229.536.536 0 0 0 .12-.338.441.441 0 0 0-.087-.284.489.489 0 0 0-.241-.186 1.484 1.484 0 0 0-.403-.087l-.852-.087a2.195 2.195 0 0 1-.862-.262 1.49 1.49 0 0 1-.557-.546 1.6 1.6 0 0 1-.197-.797c0-.349.088-.651.262-.906a1.75 1.75 0 0 1 .765-.59c.334-.145.727-.218 1.179-.218.443 0 .833.065 1.168.196.334.124.593.313.775.568.189.248.294.553.316.917h-1.299a.522.522 0 0 0-.131-.338.69.69 0 0 0-.338-.208 1.557 1.557 0 0 0-.513-.076c-.277 0-.499.051-.666.153a.488.488 0 0 0-.24.436c0 .102.025.193.076.273a.673.673 0 0 0 .262.186c.116.044.266.076.448.098l.862.098c.335.044.619.135.852.273.24.139.422.321.545.546.124.226.186.484.186.775 0 .357-.095.67-.284.939-.182.262-.447.466-.797.611-.349.139-.757.208-1.222.208Zm4.139-6.288c0-.328.061-.604.185-.83.124-.225.298-.397.524-.513.233-.116.513-.175.841-.175h1.79v1.147h-1.496c-.174 0-.309.043-.403.131-.095.08-.142.207-.142.382v5.982h-1.299v-6.124Zm-1.365.797h4.378v1.146h-4.378v-1.146Zm7.483 5.491a2.93 2.93 0 0 1-1.441-.35 2.53 2.53 0 0 1-.983-.993c-.232-.429-.349-.924-.349-1.485 0-.553.117-1.044.349-1.473.233-.43.561-.761.983-.994.422-.24.902-.36 1.441-.36.546 0 1.026.12 1.441.36.422.233.75.564.982.994.241.422.361.913.361 1.473 0 .554-.12 1.045-.361 1.474-.232.43-.56.764-.982 1.004-.415.233-.895.35-1.441.35Zm0-1.179c.284 0 .535-.069.753-.208.218-.138.386-.331.502-.578.124-.248.186-.535.186-.863a1.9 1.9 0 0 0-.186-.862 1.352 1.352 0 0 0-.502-.579 1.378 1.378 0 0 0-.753-.207c-.277 0-.524.069-.742.207-.219.139-.39.332-.514.579a2.01 2.01 0 0 0-.174.862c0 .328.058.615.174.863.124.247.295.44.514.578.218.139.465.208.742.208Zm4.005-3.363v-.949h1.146v1.353H462c0-.283.048-.524.142-.72.095-.204.237-.36.426-.47.189-.109.418-.163.688-.163h.982v1.146h-1.124c-.211 0-.386.036-.524.109a.68.68 0 0 0-.295.328 1.351 1.351 0 0 0-.098.556v3.188h-1.299v-4.378Zm6.301 4.542c-.539 0-1.008-.12-1.408-.36a2.549 2.549 0 0 1-.917-1.005 3.22 3.22 0 0 1-.317-1.441c0-.553.113-1.044.338-1.474.226-.429.543-.764.95-1.004a2.721 2.721 0 0 1 1.419-.371c.459 0 .863.084 1.212.251.357.16.641.389.852.688.218.298.345.644.382 1.037h-1.321a.98.98 0 0 0-.371-.568c-.197-.153-.452-.229-.765-.229a1.245 1.245 0 0 0-1.189.786c-.11.247-.164.535-.164.862 0 .335.054.626.164.874.116.247.272.44.469.578.204.131.44.197.71.197.203 0 .385-.037.545-.109.168-.08.302-.19.404-.328.109-.138.182-.295.219-.469h1.321a2.404 2.404 0 0 1-1.267 1.801c-.364.189-.786.284-1.266.284Zm5.949 0c-.538 0-1.011-.117-1.419-.35-.4-.24-.709-.574-.928-1.004-.218-.429-.327-.931-.327-1.506 0-.561.109-1.052.327-1.474.219-.422.524-.746.917-.972a2.664 2.664 0 0 1 1.365-.349c.808 0 1.441.244 1.899.731.466.488.699 1.15.699 1.987 0 .08-.004.168-.011.262 0 .095-.003.193-.011.295h-4.585v-1.004h3.297v-.033c0-.357-.113-.644-.338-.863-.226-.218-.543-.327-.95-.327-.277 0-.517.055-.721.164a1.138 1.138 0 0 0-.458.469 1.542 1.542 0 0 0-.153.699v.742c0 .299.055.557.164.775.109.219.269.386.48.502.211.11.466.164.764.164.27 0 .495-.054.677-.164.189-.116.331-.269.426-.458h1.332a2.64 2.64 0 0 1-.492.917 2.164 2.164 0 0 1-.818.589 2.889 2.889 0 0 1-1.136.208Z"
        />
        <rect
          width={71.111}
          height={21.833}
          x={486.058}
          y={173.408}
          fill="#F8F9FB"
          rx={3.639}
        />
        <path
          fill="url(#Z)"
          fillRule="evenodd"
          d="M489.697 187.964h7.356l7.199-7.278h-14.555v7.278Z"
          clipRule="evenodd"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M498.335 182.142h-1.438l.005 3.417-1.252-3.418h-1.241l-1.068 2.855c-.114-.727-.857-.978-1.442-1.165-.386-.126-.796-.31-.792-.514.004-.167.22-.322.649-.299.288.016.542.039 1.048.286l.498-.876a3.821 3.821 0 0 0-1.623-.388h-.003c-.61 0-1.118.2-1.433.529-.22.229-.338.521-.343.844-.008.445.153.76.492 1.012.286.212.652.349.974.45.398.124.723.233.719.463a.344.344 0 0 1-.095.227c-.099.103-.251.142-.461.146-.406.009-.707-.056-1.186-.342l-.443.888c.479.275.987.413 1.565.413l.13-.001c.503-.009.911-.131 1.235-.394l.052-.046-.054.283 1.213-.004.217-.563c.229.079.489.123.766.123.269 0 .522-.042.746-.116l.152.556 2.176.003.005-1.284h.463c1.12 0 1.781-.576 1.781-1.542 0-1.075-.643-1.543-2.012-1.543Zm-3.311 2.921c-.168 0-.325-.03-.459-.081l.453-1.449h.009l.447 1.453a1.35 1.35 0 0 1-.451.077h.001Zm3.395-.832h-.316v-1.167h.316c.421 0 .757.141.757.576 0 .449-.336.591-.757.591"
          clipRule="evenodd"
        />
        <path
          fill="#1C2938"
          d="M510.66 181.183h4.837v1.256h-3.92l.426-.415v5.96l-.426-.414h3.92v1.255h-4.837v-7.642Zm.776 3.002h4.061v1.256h-4.061v-1.256Zm5.425.262v-.949h1.147v1.048l-.219.032c.088-.291.208-.527.361-.709.152-.182.334-.317.545-.404.212-.087.448-.131.71-.131.269 0 .509.051.721.153.218.094.4.233.545.415.153.174.262.385.328.633l-.317.098c.109-.298.251-.542.426-.731.175-.19.371-.332.59-.426a1.86 1.86 0 0 1 .731-.142c.408 0 .757.084 1.048.251.291.167.513.411.666.731.153.313.229.692.229 1.136v3.373h-1.31v-3.286c0-.225-.033-.411-.098-.557a.742.742 0 0 0-.295-.349.905.905 0 0 0-.48-.12.887.887 0 0 0-.481.131.905.905 0 0 0-.327.371c-.08.16-.12.346-.12.557v3.253h-1.299v-3.286c0-.225-.033-.411-.098-.557a.742.742 0 0 0-.295-.349.906.906 0 0 0-.481-.12.905.905 0 0 0-.807.513c-.08.16-.12.342-.12.546v3.253h-1.3v-4.378Zm10.581 4.542c-.407 0-.764-.069-1.07-.208a1.655 1.655 0 0 1-.709-.578 1.648 1.648 0 0 1-.24-.895c0-.335.072-.626.218-.874.145-.254.364-.455.655-.6.291-.153.648-.244 1.07-.273l1.877-.109v.971l-1.681.142a1.058 1.058 0 0 0-.469.12.744.744 0 0 0-.284.251.616.616 0 0 0-.087.328c0 .131.032.247.098.349a.66.66 0 0 0 .306.23c.138.051.302.076.491.076.24 0 .451-.044.633-.131a.955.955 0 0 0 .437-.393 1.23 1.23 0 0 0 .163-.644v-1.539a.928.928 0 0 0-.098-.459.611.611 0 0 0-.295-.262 1.28 1.28 0 0 0-.513-.087c-.211 0-.382.022-.513.065a.559.559 0 0 0-.305.197.77.77 0 0 0-.153.349h-1.288c.036-.371.145-.68.327-.928.182-.247.44-.433.775-.557.335-.131.75-.196 1.245-.196.429 0 .797.073 1.102.218.306.139.539.342.699.612.167.269.251.593.251.971v2.478c0 .051.015.091.044.12.029.03.069.044.12.044h.469v1.048h-.982a.787.787 0 0 1-.328-.065.497.497 0 0 1-.207-.197.67.67 0 0 1-.066-.306v-.764l.197.142a1.257 1.257 0 0 1-.284.71 1.679 1.679 0 0 1-.666.48c-.277.109-.59.164-.939.164Zm4.302-4.542v-.949h1.146v1.353h-.043c0-.283.047-.524.142-.72.094-.204.236-.36.425-.47.189-.109.419-.163.688-.163h.983v1.146h-1.125c-.211 0-.386.036-.524.109a.686.686 0 0 0-.295.328 1.368 1.368 0 0 0-.098.556v3.188h-1.299v-4.378Zm6.089 4.542c-.48 0-.898-.066-1.255-.197a1.813 1.813 0 0 1-.819-.578 1.677 1.677 0 0 1-.305-.939h1.342a.662.662 0 0 0 .153.371.797.797 0 0 0 .36.229c.161.044.35.066.568.066.197 0 .364-.026.502-.077a.75.75 0 0 0 .328-.229.536.536 0 0 0 .12-.338.441.441 0 0 0-.087-.284.489.489 0 0 0-.241-.186 1.483 1.483 0 0 0-.404-.087l-.851-.087a2.195 2.195 0 0 1-.862-.262 1.49 1.49 0 0 1-.557-.546 1.6 1.6 0 0 1-.197-.797c0-.349.088-.651.262-.906.182-.255.437-.451.764-.59.335-.145.728-.218 1.179-.218a3.2 3.2 0 0 1 1.169.196c.334.124.593.313.775.568.189.248.294.553.316.917h-1.299a.522.522 0 0 0-.131-.338.69.69 0 0 0-.338-.208 1.557 1.557 0 0 0-.513-.076c-.277 0-.499.051-.666.153a.488.488 0 0 0-.24.436c0 .102.025.193.076.273a.673.673 0 0 0 .262.186c.116.044.266.076.448.098l.862.098c.335.044.619.135.851.273.241.139.423.321.546.546.124.226.186.484.186.775 0 .357-.095.67-.284.939-.182.262-.448.466-.797.611-.349.139-.757.208-1.223.208Zm2.833.644h1.037a.7.7 0 0 0 .371-.087.562.562 0 0 0 .219-.273l.644-1.42-.055 1.027-2.402-5.382h1.485l1.572 3.842h-.327l1.561-3.842h1.452l-2.882 6.462a1.74 1.74 0 0 1-.295.459.887.887 0 0 1-.404.273c-.16.065-.368.098-.622.098h-1.354v-1.157Zm8.255-.644c-.481 0-.899-.066-1.256-.197a1.804 1.804 0 0 1-.818-.578 1.67 1.67 0 0 1-.306-.939h1.343a.649.649 0 0 0 .153.371.786.786 0 0 0 .36.229c.16.044.349.066.567.066.197 0 .364-.026.503-.077a.752.752 0 0 0 .327-.229.536.536 0 0 0 .12-.338.441.441 0 0 0-.087-.284.49.49 0 0 0-.24-.186 1.492 1.492 0 0 0-.404-.087l-.852-.087a2.195 2.195 0 0 1-.862-.262 1.498 1.498 0 0 1-.557-.546 1.599 1.599 0 0 1-.196-.797c0-.349.087-.651.262-.906.182-.255.436-.451.764-.59.335-.145.728-.218 1.179-.218.444 0 .833.065 1.168.196.335.124.593.313.775.568.189.248.295.553.317.917h-1.3a.522.522 0 0 0-.131-.338.686.686 0 0 0-.338-.208 1.557 1.557 0 0 0-.513-.076c-.277 0-.499.051-.666.153a.488.488 0 0 0-.24.436c0 .102.025.193.076.273a.673.673 0 0 0 .262.186c.117.044.266.076.448.098l.862.098c.335.044.619.135.852.273.24.139.422.321.546.546.123.226.185.484.185.775 0 .357-.094.67-.284.939-.182.262-.447.466-.797.611-.349.139-.756.208-1.222.208Z"
        />
        <rect
          width={22.097}
          height={18.007}
          x={560.887}
          y={175.322}
          fill="#E9EBED"
          rx={9.003}
        />
        <path
          fill="#1C2938"
          d="M566.278 184.835v-1.091h2.151v-2.216h1.135v2.216h2.162v1.091h-2.162v2.216h-1.135v-2.216h-2.151Zm6.011 3.035a2.99 2.99 0 0 1 .316-1.255c.197-.4.408-.721.633-.961a8.42 8.42 0 0 1 .852-.753c.116-.095.298-.233.546-.415.254-.182.444-.324.567-.426a5.9 5.9 0 0 0 .415-.382c.16-.16.273-.32.339-.48.065-.168.098-.342.098-.524 0-.357-.091-.641-.273-.852-.182-.211-.437-.316-.764-.316-.379 0-.677.131-.895.393-.211.262-.321.637-.328 1.124h-1.397c0-.873.222-1.554.666-2.041.451-.495 1.113-.743 1.987-.743.786 0 1.404.23 1.855.688.459.459.688 1.026.688 1.703 0 .335-.051.641-.153.917a2.1 2.1 0 0 1-.458.743c-.211.225-.4.403-.568.534-.167.131-.4.295-.698.492-.816.524-1.318.968-1.507 1.332h3.45v1.222h-5.371Z"
        />
        <path
          stroke="#7E8793"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.115}
          d="m619.814 182.838-2.974 2.974-2.975-2.974"
        />
      </g>
      <g filter="url(#aa)">
        <path fill="#fff" d="M384.101 212.744H637.66v56.838H384.101z" />
        <rect
          width={237.944}
          height={26.769}
          x={393.024}
          y={227.779}
          fill="#F9F9F9"
          rx={4.461}
        />
        <path
          stroke="#DDDDE0"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.115}
          d="m619.814 239.676-2.974 2.974-2.975-2.974"
        />
      </g>
      <g filter="url(#ab)">
        <path fill="#fff" d="M384.101 269.582H637.66v56.838H384.101z" />
        <rect
          width={237.944}
          height={26.769}
          x={393.024}
          y={284.617}
          fill="#F9F9F9"
          rx={4.461}
        />
        <path
          stroke="#DDDDE0"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.115}
          d="m619.814 296.514-2.974 2.975-2.975-2.975"
        />
      </g>
      <g filter="url(#ac)">
        <path fill="#fff" d="M384.101 326.421H637.66v56.838H384.101z" />
        <rect
          width={237.944}
          height={26.769}
          x={393.024}
          y={341.455}
          fill="#F9F9F9"
          rx={4.461}
        />
        <path
          stroke="#DDDDE0"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.115}
          d="m619.814 353.352-2.974 2.975-2.975-2.975"
        />
      </g>
      <g filter="url(#ad)">
        <path fill="#fff" d="M384.101 383.259H637.66v56.838H384.101z" />
        <rect
          width={237.944}
          height={26.769}
          x={393.024}
          y={398.293}
          fill="#F9F9F9"
          rx={4.461}
        />
        <path
          stroke="#DDDDE0"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.115}
          d="m619.814 410.191-2.974 2.974-2.975-2.974"
        />
      </g>
      <g filter="url(#ae)">
        <path fill="#fff" d="M637.66 57.428h439v42h-439z" />
        <path
          fill="#535F6E"
          d="M650.333 75.925h1.535l1.856 5.22h-.303l1.865-5.22h1.534v6.246h-1.07v-5.255l.187.017-1.874 5.238h-.981l-1.865-5.238.178-.017v5.255h-1.062v-6.246Zm10.141 0h1.508l2.302 6.246h-1.205l-2.025-5.8h.348l-2.043 5.8h-1.196l2.311-6.246Zm-.874 3.543h3.239v.999H659.6v-1Zm6.021-3.543h2.739c.434 0 .809.075 1.124.223.322.149.569.363.741.643.173.28.259.612.259 1 0 .386-.086.719-.259.999-.172.28-.419.496-.741.65-.315.15-.69.224-1.124.224l-.33-.027h-1.811v-1h2.141c.214 0 .396-.032.544-.097a.774.774 0 0 0 .348-.295.842.842 0 0 0 .116-.455.797.797 0 0 0-.116-.446.725.725 0 0 0-.348-.286 1.249 1.249 0 0 0-.544-.107h-1.99l.348-.339v5.56h-1.097v-6.247Zm1.668 3.534 1.062-.366 2.311 3.078h-1.356l-2.017-2.712Zm6.661 0h-.893v-1.125h.875l2.025-2.409h1.348l-2.677 3.186.018-.536 2.659 3.596h-1.348l-2.007-2.712Zm-1.722-3.534h1.097v6.246h-1.097v-6.246Zm6.441 0h3.953v1.026h-3.204l.348-.339v4.872l-.348-.339h3.204v1.026h-3.953v-6.246Zm.633 2.454h3.32v1.026h-3.32V78.38Zm6.457-1.57h1.098v5.362h-1.098V76.81Zm-1.927-.884h4.952v1.026h-4.952v-1.026Zm6.316 0h1.098v6.246h-1.098v-6.246Zm3.096 0h1.32l2.775 4.845-.187.054v-4.899h1.097v6.246h-1.32l-2.784-4.845.196-.053v4.898h-1.097v-6.246Zm9.452 6.38c-.541 0-1.02-.128-1.436-.384-.417-.255-.741-.627-.973-1.115-.232-.488-.348-1.07-.348-1.749 0-.672.116-1.255.348-1.749.232-.493.562-.868.99-1.124.429-.262.934-.393 1.517-.393.476 0 .896.084 1.258.25.363.16.655.399.875.714.226.315.366.693.419 1.133h-1.142a1.303 1.303 0 0 0-.25-.57 1.154 1.154 0 0 0-.481-.376 1.63 1.63 0 0 0-.679-.133c-.357 0-.666.086-.928.258-.255.167-.452.42-.589.759-.136.339-.205.752-.205 1.24 0 .494.069.907.205 1.24.143.328.348.574.616.741.268.16.589.24.964.24.285 0 .535-.056.749-.169.22-.113.39-.282.509-.508a1.82 1.82 0 0 0 .178-.839l.322.259h-2.338v-1h3.069v3.141h-.91v-1.32l.223.053a1.481 1.481 0 0 1-.348.723c-.178.214-.407.38-.687.5a2.305 2.305 0 0 1-.928.178Zm9.695 0c-.565 0-1.062-.119-1.49-.357-.422-.244-.752-.61-.99-1.097-.238-.488-.357-1.086-.357-1.794s.116-1.306.348-1.793c.238-.494.568-.863.99-1.107.429-.244.934-.366 1.517-.366.458 0 .866.087 1.223.26.356.166.648.413.874.74.226.327.372.722.437 1.187h-1.151a1.406 1.406 0 0 0-.259-.634 1.195 1.195 0 0 0-.481-.393 1.499 1.499 0 0 0-.643-.133c-.351 0-.654.077-.91.231-.256.15-.455.39-.598.723-.143.333-.214.759-.214 1.276 0 .506.071.925.214 1.258.149.334.351.58.607.741.256.155.55.232.883.232.256 0 .482-.05.678-.152a1.21 1.21 0 0 0 .473-.428c.125-.19.209-.413.25-.67h1.142a3.208 3.208 0 0 1-.446 1.214c-.22.34-.508.601-.865.785a2.648 2.648 0 0 1-1.232.277Zm6.651 0c-.559 0-1.056-.125-1.49-.375-.429-.25-.762-.618-1-1.106-.238-.494-.357-1.086-.357-1.776s.119-1.279.357-1.767c.238-.493.571-.865 1-1.115.434-.25.931-.375 1.49-.375.565 0 1.062.125 1.49.375.428.25.761.622.999 1.115.238.488.357 1.077.357 1.767s-.119 1.282-.357 1.776c-.238.488-.571.856-.999 1.106-.428.25-.925.375-1.49.375Zm0-1.026c.339 0 .636-.08.892-.24.262-.168.464-.417.607-.75.143-.34.214-.753.214-1.24 0-.489-.071-.899-.214-1.232-.143-.34-.345-.589-.607-.75a1.598 1.598 0 0 0-.892-.25c-.339 0-.637.084-.892.25-.256.161-.458.41-.607.75-.143.333-.214.744-.214 1.231 0 .488.071.901.214 1.24.149.334.351.584.607.75.255.16.553.241.892.241Zm4.552-5.354h1.534l1.856 5.22h-.303l1.865-5.22h1.535v6.246h-1.071v-5.255l.187.017-1.874 5.238h-.981l-1.865-5.238.178-.017v5.255h-1.061v-6.246Zm8.489 0h1.534l1.856 5.22h-.303l1.865-5.22h1.534v6.246h-1.07v-5.255l.187.017-1.874 5.238h-.981l-1.865-5.238.178-.017v5.255h-1.061v-6.246Zm10.826 6.38c-.499 0-.934-.098-1.302-.294a2.076 2.076 0 0 1-.839-.857c-.191-.375-.286-.818-.286-1.33v-3.899h1.098v3.82c0 .326.05.606.151.838.108.226.259.398.456.517.202.12.443.179.722.179.28 0 .518-.06.714-.178.202-.12.354-.292.455-.518.107-.232.161-.512.161-.839v-3.819h1.106v3.9c0 .511-.098.954-.294 1.33-.191.368-.47.653-.839.856-.363.196-.797.294-1.303.294Zm4.339-6.38h1.321l2.775 4.845-.188.054v-4.899h1.098v6.246h-1.321l-2.784-4.845.196-.053v4.898h-1.097v-6.246Zm6.999 0h1.097v6.246h-1.097v-6.246Zm5.629 6.38c-.565 0-1.062-.119-1.49-.357-.422-.244-.753-.61-.99-1.097-.238-.488-.357-1.086-.357-1.794s.116-1.306.348-1.793c.238-.494.568-.863.99-1.107.428-.244.934-.366 1.517-.366.458 0 .865.087 1.222.26.357.166.649.413.875.74.226.327.372.722.437 1.187h-1.151a1.417 1.417 0 0 0-.259-.634 1.191 1.191 0 0 0-.482-.393 1.491 1.491 0 0 0-.642-.133c-.351 0-.654.077-.91.231-.256.15-.455.39-.598.723-.143.333-.214.759-.214 1.276 0 .506.071.925.214 1.258.149.334.351.58.607.741.256.155.55.232.883.232.256 0 .482-.05.678-.152a1.21 1.21 0 0 0 .473-.428c.125-.19.208-.413.25-.67h1.142a3.208 3.208 0 0 1-.446 1.214c-.22.34-.509.601-.866.785a2.64 2.64 0 0 1-1.231.277Zm5.689-6.38h1.508l2.303 6.246h-1.205l-2.026-5.8h.348l-2.043 5.8h-1.196l2.311-6.246Zm-.874 3.543h3.239v.999h-3.239v-1Zm6.714-2.66h1.098v5.363h-1.098V76.81Zm-1.927-.883h4.952v1.026h-4.952v-1.026Zm6.316 0h1.098v6.246h-1.098v-6.246Zm5.638 6.38c-.559 0-1.055-.125-1.49-.375-.428-.25-.761-.618-.999-1.106-.238-.494-.357-1.086-.357-1.776s.119-1.279.357-1.767c.238-.493.571-.865.999-1.115.435-.25.931-.375 1.49-.375.566 0 1.062.125 1.491.375.428.25.761.622.999 1.115.238.488.357 1.077.357 1.767s-.119 1.282-.357 1.776c-.238.488-.571.856-.999 1.106-.429.25-.925.375-1.491.375Zm0-1.026c.34 0 .637-.08.893-.24.261-.168.464-.417.606-.75.143-.34.215-.753.215-1.24 0-.489-.072-.899-.215-1.232-.142-.34-.345-.589-.606-.75a1.599 1.599 0 0 0-.893-.25c-.339 0-.636.084-.892.25-.256.161-.458.41-.607.75-.142.333-.214.744-.214 1.231 0 .488.072.901.214 1.24.149.334.351.584.607.75.256.16.553.241.892.241Zm4.552-5.354h1.321l2.775 4.845-.188.054v-4.899h1.098v6.246h-1.321l-2.784-4.845.197-.053v4.898h-1.098v-6.246Zm9.105 6.38c-.524 0-.976-.08-1.356-.24a1.94 1.94 0 0 1-.875-.715c-.202-.315-.306-.687-.312-1.115h1.124c.006.22.066.413.179.58.113.16.276.285.49.375.214.089.464.134.75.134.25 0 .467-.04.651-.116a.934.934 0 0 0 .437-.34.892.892 0 0 0 .152-.517.757.757 0 0 0-.107-.41.689.689 0 0 0-.321-.286 1.75 1.75 0 0 0-.544-.152l-.768-.107c-.41-.053-.755-.154-1.035-.303a1.59 1.59 0 0 1-.616-.589 1.796 1.796 0 0 1-.196-.857c0-.374.095-.702.286-.981.19-.28.458-.494.803-.643.345-.154.746-.232 1.204-.232.476 0 .89.075 1.241.224.351.142.618.35.803.624.19.274.288.598.294.973h-1.115a.715.715 0 0 0-.17-.455.911.911 0 0 0-.419-.295 1.708 1.708 0 0 0-.634-.107 1.75 1.75 0 0 0-.606.098.852.852 0 0 0-.411.295.69.69 0 0 0-.143.428c0 .155.036.286.107.393a.913.913 0 0 0 .348.258c.155.066.351.113.589.143l.723.098c.405.054.741.155 1.008.304.268.148.47.35.607.606.137.25.205.55.205.902 0 .41-.095.767-.285 1.07a1.873 1.873 0 0 1-.83.705c-.357.167-.776.25-1.258.25Z"
        />
        <path
          stroke="#7E8793"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.115}
          d="M806.736 82.332v0a3.903 3.903 0 0 1-3.903-3.904v0a3.903 3.903 0 0 1 3.903-3.904v0a3.903 3.903 0 0 1 3.904 3.904v0a3.903 3.903 0 0 1-3.904 3.904Z"
          clipRule="evenodd"
        />
        <path
          stroke="#7E8793"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.115}
          d="M806.736 80.597v-2.17h-.433M806.628 76.693a.107.107 0 0 0-.108.108.108.108 0 1 0 .216 0 .108.108 0 0 0-.108-.108"
        />
      </g>
      <g filter="url(#af)">
        <path fill="#fff" d="M637.66 99.428h438.994v56.778H637.66z" />
        <g clipPath="url(#ag)">
          <rect
            width={172.405}
            height={31.155}
            x={646.583}
            y={112.239}
            fill="#F9F9F9"
            rx={3.688}
          />
          <path
            stroke="#E9EBED"
            strokeWidth={0.922}
            d="M732.784 112.239v31.155"
          />
          <rect
            width={172.405}
            height={31.155}
            x={822.706}
            y={112.239}
            fill="#F9F9F9"
            rx={3.688}
          />
          <path
            stroke="#E9EBED"
            strokeWidth={0.922}
            d="M908.907 112.239v31.155"
          />
        </g>
      </g>
      <g filter="url(#ah)">
        <path fill="#fff" d="M637.66 156.206h438.994v56.778H637.66z" />
        <g clipPath="url(#ai)">
          <rect
            width={212.712}
            height={30.233}
            x={647.044}
            y={169.479}
            fill="#fff"
            rx={3.227}
          />
          <rect
            width={212.712}
            height={30.233}
            x={647.044}
            y={169.479}
            stroke="#E9EBED"
            strokeWidth={0.922}
            rx={3.227}
          />
          <path
            fill="#FFCD00"
            d="M663.17 185.333a2.953 2.953 0 0 0 2.727-1.822 2.952 2.952 0 1 0-2.727 1.822Z"
          />
          <path
            fill="#00ECBB"
            d="M663.189 186.808h-.01a4.431 4.431 0 0 1-4.291-3.335c-.148-.59-.628-1.089-1.236-1.089h-1.849a7.373 7.373 0 0 0 7.376 7.374h.01v-2.95Z"
          />
          <path
            fill="#AF64FF"
            d="M663.17 186.808h.009a4.427 4.427 0 0 0 4.29-3.335c.15-.59.63-1.089 1.238-1.089h1.849a7.378 7.378 0 0 1-7.377 7.374h-.009v-2.95Z"
          />
          <path
            fill="#7131FF"
            d="M668.395 187.598a7.38 7.38 0 0 1-8.038 1.599 7.38 7.38 0 0 1-2.393-1.599l2.086-2.086a4.426 4.426 0 0 0 6.259 0l2.086 2.086Z"
          />
          <path
            fill="#1C2938"
            d="M680.137 189.259c-.691 0-1.299-.146-1.823-.437-.516-.298-.92-.746-1.211-1.342-.291-.597-.437-1.328-.437-2.194 0-.866.142-1.597.426-2.193.291-.604.695-1.055 1.211-1.354.524-.298 1.143-.447 1.856-.447.56 0 1.058.105 1.495.316.436.204.793.506 1.069.906.277.4.455.884.535 1.452h-1.408a1.73 1.73 0 0 0-.316-.775 1.464 1.464 0 0 0-.59-.48 1.825 1.825 0 0 0-.785-.164c-.43 0-.801.095-1.114.284-.312.182-.556.476-.731.884-.174.407-.262.927-.262 1.56 0 .619.088 1.132.262 1.539.182.408.429.71.742.906a2.05 2.05 0 0 0 1.081.284c.313 0 .589-.062.829-.186s.433-.298.579-.524c.152-.232.254-.505.305-.818h1.397a3.924 3.924 0 0 1-.546 1.484 2.737 2.737 0 0 1-1.058.96c-.437.226-.939.339-1.506.339Zm6.236 0c-.429 0-.804-.088-1.124-.262a1.806 1.806 0 0 1-.72-.775c-.167-.342-.251-.753-.251-1.233v-3.22h1.299v3.089c0 .276.04.505.12.687.08.175.196.31.349.404.16.087.353.131.578.131.233 0 .433-.051.6-.153.175-.109.31-.258.404-.447.095-.189.142-.411.142-.666v-3.045h1.299v5.326h-1.146v-1.2l.284.109a1.56 1.56 0 0 1-.382.687 1.76 1.76 0 0 1-.644.426 2.26 2.26 0 0 1-.808.142Zm6.138 0c-.48 0-.899-.066-1.255-.197a1.8 1.8 0 0 1-.819-.578 1.677 1.677 0 0 1-.305-.939h1.342c.014.146.065.27.153.371a.788.788 0 0 0 .36.23 2.2 2.2 0 0 0 .567.065c.197 0 .364-.025.502-.076a.759.759 0 0 0 .328-.23.532.532 0 0 0 .12-.338.438.438 0 0 0-.088-.284.48.48 0 0 0-.24-.185 1.412 1.412 0 0 0-.403-.087l-.852-.088a2.168 2.168 0 0 1-.862-.262 1.485 1.485 0 0 1-.556-.545 1.6 1.6 0 0 1-.197-.797c0-.349.087-.651.262-.906.182-.254.437-.451.764-.589.335-.146.728-.218 1.179-.218.443 0 .833.065 1.167.196.335.124.593.313.775.568.189.247.295.552.317.916h-1.299a.522.522 0 0 0-.131-.338.682.682 0 0 0-.338-.207 1.556 1.556 0 0 0-.513-.077c-.277 0-.499.051-.666.153a.488.488 0 0 0-.24.437c0 .101.026.192.076.272a.681.681 0 0 0 .262.186c.117.044.266.076.448.098l.862.098c.335.044.618.135.851.273.24.138.422.32.546.546.124.225.185.484.185.775 0 .356-.094.669-.283.938-.182.262-.448.466-.797.611-.349.139-.757.208-1.222.208Zm5.491-.164c-.32 0-.582-.044-.786-.131a.912.912 0 0 1-.437-.436c-.094-.197-.142-.459-.142-.786v-5.533h1.299v5.238c0 .175.04.302.12.382.08.08.208.12.382.12h1.124v1.146h-1.56Zm-2.729-5.326h4.289v1.146h-4.289v-1.146Zm7.673 5.49a2.937 2.937 0 0 1-1.44-.349 2.539 2.539 0 0 1-.983-.994c-.233-.429-.349-.924-.349-1.484 0-.553.116-1.044.349-1.473.233-.429.561-.76.983-.993.421-.24.902-.36 1.44-.36.546 0 1.026.12 1.441.36.422.233.749.564.982.993.24.422.36.913.36 1.473 0 .553-.12 1.044-.36 1.473-.233.43-.56.764-.982 1.005-.415.232-.895.349-1.441.349Zm0-1.179c.284 0 .535-.069.753-.207a1.34 1.34 0 0 0 .502-.579c.124-.247.186-.534.186-.862a1.9 1.9 0 0 0-.186-.862 1.343 1.343 0 0 0-.502-.578 1.37 1.37 0 0 0-.753-.208c-.276 0-.524.069-.742.208a1.422 1.422 0 0 0-.513.578 2.01 2.01 0 0 0-.175.862c0 .328.059.615.175.862a1.36 1.36 0 0 0 1.255.786Zm4.004-3.361v-.95h1.145v1.048l-.218.033c.087-.291.208-.528.36-.71.153-.182.335-.316.546-.403.211-.088.447-.131.709-.131.27 0 .51.051.721.152.218.095.4.233.545.415.153.175.262.386.328.633l-.317.098c.109-.298.251-.542.426-.731.174-.189.371-.331.589-.426.226-.094.469-.141.731-.141.408 0 .757.083 1.048.251.291.167.513.411.666.731.153.313.229.691.229 1.135v3.372h-1.31v-3.285c0-.225-.032-.411-.098-.556a.734.734 0 0 0-.295-.35.905.905 0 0 0-.48-.12.881.881 0 0 0-.48.131.911.911 0 0 0-.327.371c-.08.16-.12.346-.12.557v3.252h-1.299v-3.285c0-.225-.033-.411-.098-.556a.74.74 0 0 0-.295-.35.905.905 0 0 0-.48-.12.9.9 0 0 0-.808.513c-.08.16-.12.342-.12.546v3.252h-1.298v-4.376Zm11.33 4.54c-.538 0-1.011-.117-1.419-.349a2.428 2.428 0 0 1-.927-1.005c-.219-.429-.328-.931-.328-1.506 0-.56.109-1.051.328-1.473.218-.422.523-.746.916-.971a2.664 2.664 0 0 1 1.365-.349c.807 0 1.44.243 1.898.731.466.487.699 1.149.699 1.986 0 .08-.004.167-.011.262 0 .095-.004.193-.011.295h-4.584v-1.004h3.296v-.033c0-.357-.112-.644-.338-.862-.226-.219-.542-.328-.949-.328-.277 0-.517.055-.721.164a1.144 1.144 0 0 0-.458.469 1.542 1.542 0 0 0-.153.699v.742c0 .298.055.556.164.775.109.218.269.385.48.502.211.109.466.163.764.163.269 0 .495-.054.677-.163.189-.117.331-.269.425-.459h1.332c-.11.35-.273.655-.492.917a2.164 2.164 0 0 1-.818.589 2.884 2.884 0 0 1-1.135.208Zm3.729-4.54v-.95h1.146v1.354h-.044c0-.284.047-.524.142-.721.094-.203.236-.36.425-.469a1.36 1.36 0 0 1 .688-.164h.982v1.146h-1.124a1.13 1.13 0 0 0-.524.109.679.679 0 0 0-.294.328 1.35 1.35 0 0 0-.099.556v3.187h-1.298v-4.376Zm3.452 2.717H727v1.659h-1.539v-1.659Zm3.07-3.667h1.299v5.326h-1.299v-5.326Zm-.044-2.259h1.397v1.332h-1.397v-1.332Zm5.334 7.749a2.944 2.944 0 0 1-1.441-.349 2.536 2.536 0 0 1-.982-.994c-.233-.429-.349-.924-.349-1.484 0-.553.116-1.044.349-1.473.233-.429.56-.76.982-.993.422-.24.903-.36 1.441-.36.546 0 1.026.12 1.441.36.422.233.749.564.982.993.24.422.36.913.36 1.473 0 .553-.12 1.044-.36 1.473-.233.43-.56.764-.982 1.005-.415.232-.895.349-1.441.349Zm0-1.179c.284 0 .535-.069.753-.207a1.34 1.34 0 0 0 .502-.579c.124-.247.186-.534.186-.862a1.9 1.9 0 0 0-.186-.862 1.343 1.343 0 0 0-.502-.578 1.37 1.37 0 0 0-.753-.208c-.276 0-.524.069-.742.208a1.422 1.422 0 0 0-.513.578 2.01 2.01 0 0 0-.175.862c0 .328.059.615.175.862a1.36 1.36 0 0 0 1.255.786Z"
          />
          <path
            stroke="#E9EBED"
            strokeWidth={0.922}
            d="M748.152 169.018v31.154"
          />
          <path
            fill="#1C2938"
            d="M757.209 189.259c-.64 0-1.193-.098-1.658-.295-.466-.204-.823-.495-1.07-.873-.247-.386-.375-.84-.382-1.364h1.375c.008.269.08.505.219.709.138.197.338.349.6.459.262.109.567.163.916.163.306 0 .572-.047.797-.142.233-.094.411-.232.535-.414.124-.182.185-.393.185-.633a.913.913 0 0 0-.131-.502.851.851 0 0 0-.392-.35 2.143 2.143 0 0 0-.666-.185l-.939-.131c-.502-.065-.924-.189-1.266-.371a1.953 1.953 0 0 1-.753-.72 2.188 2.188 0 0 1-.24-1.048c0-.458.117-.859.349-1.201.233-.341.561-.603.983-.785.422-.189.913-.284 1.473-.284.582 0 1.088.091 1.517.273.429.174.757.429.982.764.233.334.353.731.36 1.189h-1.364a.87.87 0 0 0-.207-.556 1.117 1.117 0 0 0-.513-.36 2.068 2.068 0 0 0-.775-.131c-.276 0-.524.04-.742.12-.218.08-.386.2-.502.36a.838.838 0 0 0-.175.524c0 .189.044.349.131.48.095.124.237.229.426.316.189.08.429.139.72.175l.884.12c.495.065.906.189 1.233.371.328.182.575.429.742.742.168.306.251.673.251 1.102 0 .502-.116.939-.349 1.31-.233.371-.571.658-1.015.862-.436.204-.949.306-1.539.306Zm6.143 0c-.43 0-.804-.088-1.124-.262a1.815 1.815 0 0 1-.721-.775c-.167-.342-.251-.753-.251-1.233v-3.22h1.299v3.089c0 .276.04.505.12.687.08.175.196.31.349.404.16.087.353.131.579.131.232 0 .433-.051.6-.153.174-.109.309-.258.404-.447.094-.189.142-.411.142-.666v-3.045h1.298v5.326h-1.146v-1.2l.284.109a1.56 1.56 0 0 1-.382.687 1.752 1.752 0 0 1-.644.426 2.251 2.251 0 0 1-.807.142Zm7.12 0c-.306 0-.593-.048-.863-.142a2.077 2.077 0 0 1-.676-.393 1.523 1.523 0 0 1-.393-.611l.175-.24v1.222h-1.146v-7.639h1.298v3.492l-.196-.262a1.37 1.37 0 0 1 .36-.578c.175-.168.386-.291.633-.371.247-.088.517-.131.808-.131.502 0 .945.12 1.331.36.386.233.684.564.895.993.218.422.327.913.327 1.473s-.109 1.055-.327 1.484a2.421 2.421 0 0 1-.895.994 2.532 2.532 0 0 1-1.331.349Zm-.208-1.179a1.334 1.334 0 0 0 1.233-.786c.124-.247.186-.534.186-.862a1.9 1.9 0 0 0-.186-.862 1.337 1.337 0 0 0-1.233-.786c-.284 0-.531.069-.742.208a1.45 1.45 0 0 0-.502.578 2.01 2.01 0 0 0-.175.862c0 .328.059.615.175.862.124.248.291.441.502.579.211.138.458.207.742.207Zm5.918 1.179c-.48 0-.898-.066-1.255-.197a1.797 1.797 0 0 1-.818-.578 1.67 1.67 0 0 1-.306-.939h1.342c.015.146.066.27.153.371a.788.788 0 0 0 .36.23c.16.043.349.065.568.065.196 0 .363-.025.502-.076a.761.761 0 0 0 .327-.23.532.532 0 0 0 .12-.338.443.443 0 0 0-.087-.284.49.49 0 0 0-.24-.185 1.42 1.42 0 0 0-.404-.087l-.851-.088a2.163 2.163 0 0 1-.862-.262 1.48 1.48 0 0 1-.557-.545 1.599 1.599 0 0 1-.196-.797c0-.349.087-.651.261-.906.182-.254.437-.451.764-.589.335-.146.728-.218 1.179-.218.444 0 .833.065 1.168.196.334.124.593.313.775.568.189.247.294.552.316.916h-1.299a.517.517 0 0 0-.131-.338.677.677 0 0 0-.338-.207 1.547 1.547 0 0 0-.513-.077c-.276 0-.498.051-.665.153a.487.487 0 0 0-.241.437c0 .101.026.192.077.272a.666.666 0 0 0 .262.186c.116.044.265.076.447.098l.862.098c.335.044.619.135.852.273.24.138.422.32.545.546.124.225.186.484.186.775 0 .356-.095.669-.284.938-.182.262-.447.466-.797.611-.349.139-.756.208-1.222.208Zm5.807 0c-.538 0-1.008-.12-1.408-.36a2.553 2.553 0 0 1-.917-1.004 3.226 3.226 0 0 1-.316-1.441c0-.553.113-1.044.338-1.473.226-.43.542-.764.95-1.004a2.706 2.706 0 0 1 1.418-.371c.459 0 .863.083 1.212.251.356.16.64.389.851.687.218.298.346.644.382 1.037h-1.32a.978.978 0 0 0-.372-.568c-.196-.152-.451-.229-.763-.229a1.248 1.248 0 0 0-1.19.786 2.12 2.12 0 0 0-.164.862c0 .335.055.626.164.873.116.248.273.44.469.579.204.131.44.196.71.196a1.3 1.3 0 0 0 .545-.109c.168-.08.302-.189.404-.327.109-.139.182-.295.218-.47h1.321a2.404 2.404 0 0 1-1.266 1.801c-.364.189-.786.284-1.266.284Zm3.516-4.54v-.95h1.146v1.354h-.043c0-.284.047-.524.141-.721.095-.203.237-.36.426-.469.189-.109.418-.164.688-.164h.982v1.146h-1.124c-.211 0-.386.037-.524.109a.686.686 0 0 0-.295.328 1.368 1.368 0 0 0-.098.556v3.187h-1.299v-4.376Zm4.178-.95h1.299v5.326h-1.299v-5.326Zm-.044-2.259h1.397v1.332h-1.397v-1.332Zm2.943 3.209v-.95h1.146v1.223l-.175-.24c.08-.233.211-.433.393-.601.189-.174.415-.309.677-.404.269-.094.556-.141.862-.141.502 0 .946.12 1.331.36.386.233.684.564.895.993.218.422.328.913.328 1.473s-.11 1.055-.328 1.484a2.421 2.421 0 0 1-.895.994 2.53 2.53 0 0 1-1.331.349c-.291 0-.56-.044-.808-.131a1.7 1.7 0 0 1-.633-.36 1.462 1.462 0 0 1-.36-.59l.197-.251v3.132h-1.299v-6.34Zm2.696 3.361c.276 0 .52-.069.731-.207.218-.138.385-.331.502-.579a1.91 1.91 0 0 0 .185-.862c0-.327-.062-.615-.185-.862a1.35 1.35 0 0 0-.502-.578 1.299 1.299 0 0 0-.731-.208 1.32 1.32 0 0 0-.743.208 1.45 1.45 0 0 0-.502.578 2.01 2.01 0 0 0-.174.862c0 .328.058.615.174.862.124.248.291.441.502.579.211.138.459.207.743.207Zm5.909 1.015c-.32 0-.582-.044-.786-.131a.91.91 0 0 1-.436-.436c-.095-.197-.142-.459-.142-.786v-5.533h1.299v5.238c0 .175.04.302.12.382.08.08.207.12.382.12h1.124v1.146h-1.561Zm-2.728-5.326h4.289v1.146h-4.289v-1.146Zm5.367 0h1.298v5.326h-1.298v-5.326Zm-.044-2.259h1.397v1.332h-1.397v-1.332Zm5.334 7.749a2.941 2.941 0 0 1-1.441-.349 2.536 2.536 0 0 1-.982-.994c-.233-.429-.349-.924-.349-1.484 0-.553.116-1.044.349-1.473.233-.429.56-.76.982-.993.422-.24.902-.36 1.441-.36.545 0 1.025.12 1.44.36.422.233.75.564.982.993.24.422.36.913.36 1.473 0 .553-.12 1.044-.36 1.473-.232.43-.56.764-.982 1.005-.415.232-.895.349-1.44.349Zm0-1.179c.283 0 .534-.069.753-.207.218-.138.385-.331.502-.579a1.91 1.91 0 0 0 .185-.862c0-.327-.062-.615-.185-.862a1.35 1.35 0 0 0-.502-.578 1.375 1.375 0 0 0-.753-.208c-.277 0-.524.069-.743.208a1.413 1.413 0 0 0-.512.578 1.995 1.995 0 0 0-.175.862c0 .328.058.615.175.862.123.248.294.441.512.579.219.138.466.207.743.207Zm4.003-3.361v-.95h1.146v1.07l-.196.076c.05-.276.16-.513.327-.709.175-.197.386-.346.633-.448a2.23 2.23 0 0 1 .829-.152c.437 0 .812.091 1.124.272.32.175.564.433.732.775.174.335.261.742.261 1.223v3.219h-1.298v-3.088c0-.277-.044-.502-.131-.677a.817.817 0 0 0-.36-.404 1.148 1.148 0 0 0-.59-.142c-.232 0-.44.055-.622.164a1.089 1.089 0 0 0-.414.436c-.095.19-.142.412-.142.666v3.045h-1.299v-4.376Zm10.848-2.183h1.342v6.559h-1.342v-6.559Zm-2.358-1.08h6.057v1.255h-6.057v-1.255Zm8.459 7.803a2.94 2.94 0 0 1-1.44-.349 2.53 2.53 0 0 1-.982-.994c-.233-.429-.35-.924-.35-1.484 0-.553.117-1.044.35-1.473.232-.429.56-.76.982-.993.422-.24.902-.36 1.44-.36.546 0 1.026.12 1.441.36.422.233.749.564.982.993.24.422.36.913.36 1.473 0 .553-.12 1.044-.36 1.473-.233.43-.56.764-.982 1.005-.415.232-.895.349-1.441.349Zm0-1.179c.284 0 .535-.069.753-.207.219-.138.386-.331.502-.579.124-.247.186-.534.186-.862a1.9 1.9 0 0 0-.186-.862 1.337 1.337 0 0 0-1.255-.786c-.276 0-.524.069-.742.208a1.422 1.422 0 0 0-.513.578 2.01 2.01 0 0 0-.174.862c0 .328.058.615.174.862a1.36 1.36 0 0 0 1.255.786Zm4.025-3.361v-.95h1.146v1.223l-.175-.24c.08-.233.211-.433.393-.601.189-.174.415-.309.677-.404.269-.094.557-.141.862-.141.502 0 .946.12 1.332.36.385.233.683.564.894.993.219.422.328.913.328 1.473s-.109 1.055-.328 1.484a2.426 2.426 0 0 1-.894.994c-.386.232-.83.349-1.332.349-.291 0-.56-.044-.807-.131-.248-.08-.459-.2-.633-.36a1.454 1.454 0 0 1-.361-.59l.197-.251v3.132h-1.299v-6.34Zm2.696 3.361a1.34 1.34 0 0 0 1.233-.786c.124-.247.185-.534.185-.862a1.9 1.9 0 0 0-.185-.862 1.343 1.343 0 0 0-1.233-.786c-.284 0-.531.069-.742.208a1.442 1.442 0 0 0-.502.578 1.995 1.995 0 0 0-.175.862c0 .328.058.615.175.862.123.248.291.441.502.579.211.138.458.207.742.207Zm3.997-4.311h1.299v5.326h-1.299v-5.326Zm-.044-2.259h1.397v1.332h-1.397v-1.332Zm5.203 7.749c-.538 0-1.008-.12-1.408-.36a2.553 2.553 0 0 1-.917-1.004 3.226 3.226 0 0 1-.316-1.441c0-.553.113-1.044.338-1.473.226-.43.542-.764.95-1.004a2.707 2.707 0 0 1 1.419-.371c.458 0 .862.083 1.211.251.356.16.64.389.851.687.218.298.346.644.382 1.037h-1.32a.98.98 0 0 0-.371-.568c-.197-.152-.452-.229-.764-.229a1.248 1.248 0 0 0-1.19.786 2.12 2.12 0 0 0-.164.862c0 .335.055.626.164.873.116.248.273.44.469.579.204.131.44.196.71.196a1.3 1.3 0 0 0 .545-.109c.168-.08.302-.189.404-.327.109-.139.182-.295.218-.47h1.321a2.404 2.404 0 0 1-1.266 1.801c-.364.189-.786.284-1.266.284Zm5.554 0c-.48 0-.898-.066-1.255-.197a1.797 1.797 0 0 1-.818-.578 1.678 1.678 0 0 1-.306-.939h1.342c.015.146.066.27.153.371a.788.788 0 0 0 .36.23c.16.043.349.065.568.065.196 0 .364-.025.502-.076a.761.761 0 0 0 .327-.23.532.532 0 0 0 .12-.338.443.443 0 0 0-.087-.284.49.49 0 0 0-.24-.185 1.42 1.42 0 0 0-.404-.087l-.851-.088a2.163 2.163 0 0 1-.862-.262 1.488 1.488 0 0 1-.557-.545 1.599 1.599 0 0 1-.196-.797c0-.349.087-.651.261-.906.182-.254.437-.451.764-.589.335-.146.728-.218 1.179-.218.444 0 .833.065 1.168.196.334.124.593.313.775.568.189.247.294.552.316.916h-1.299a.517.517 0 0 0-.131-.338.677.677 0 0 0-.338-.207 1.547 1.547 0 0 0-.513-.077c-.276 0-.498.051-.665.153a.487.487 0 0 0-.241.437c0 .101.026.192.077.272a.666.666 0 0 0 .262.186c.116.044.265.076.447.098l.862.098c.335.044.619.135.852.273.24.138.422.32.545.546.124.225.186.484.186.775 0 .356-.095.669-.284.938-.182.262-.447.466-.797.611-.349.139-.756.208-1.222.208Z"
          />
          <rect
            width={163.712}
            height={30.233}
            x={864.396}
            y={169.479}
            fill="#fff"
            rx={3.227}
          />
          <rect
            width={163.712}
            height={30.233}
            x={864.396}
            y={169.479}
            stroke="#E9EBED"
            strokeWidth={0.922}
            rx={3.227}
          />
          <path
            fill="#5C4C9F"
            d="M883.028 177.219v14.752l3.782-3.009v-9.696l-3.782-2.047ZM881.273 188.75l-3.054 1.327v-11.581l3.054.906v9.348ZM874.138 188.407l2.327-.608.001-7.398-2.326-.368-.002 8.374Z"
          />
          <path
            fill="#1C2938"
            d="M894.389 181.456h1.877l2.27 6.384h-.371l2.281-6.384h1.877v7.639h-1.31v-6.428l.23.022-2.292 6.406h-1.201l-2.28-6.406.218-.022v6.428h-1.299v-7.639Zm11.245 7.803c-.407 0-.764-.069-1.069-.208a1.658 1.658 0 0 1-.71-.578 1.648 1.648 0 0 1-.24-.895c0-.335.073-.626.219-.873.145-.255.363-.455.654-.6.291-.153.648-.244 1.07-.273l1.877-.109v.971l-1.681.142a1.035 1.035 0 0 0-.469.12.735.735 0 0 0-.284.251.615.615 0 0 0-.087.327c0 .131.033.248.098.35a.658.658 0 0 0 .306.229c.138.051.302.076.491.076.24 0 .451-.043.633-.131a.947.947 0 0 0 .436-.393c.11-.182.164-.396.164-.644v-1.538a.941.941 0 0 0-.098-.459.62.62 0 0 0-.295-.262 1.28 1.28 0 0 0-.513-.087c-.211 0-.382.022-.513.066a.556.556 0 0 0-.305.196.77.77 0 0 0-.153.349h-1.288c.037-.371.146-.68.328-.927.182-.248.44-.433.775-.557.334-.131.749-.196 1.244-.196.429 0 .796.072 1.102.218.306.138.538.342.698.611.168.269.251.593.251.971v2.478c0 .051.015.091.044.12a.162.162 0 0 0 .12.043h.469v1.048h-.982a.779.779 0 0 1-.327-.065.493.493 0 0 1-.208-.197.682.682 0 0 1-.065-.305v-.764l.196.141c-.021.27-.116.506-.283.71-.168.204-.39.364-.666.48a2.543 2.543 0 0 1-.939.164Zm4.301-4.54v-.95h1.146v1.354h-.044c0-.284.047-.524.142-.721.095-.203.236-.36.426-.469.189-.109.418-.164.687-.164h.982v1.146h-1.124a1.13 1.13 0 0 0-.524.109.684.684 0 0 0-.294.328 1.351 1.351 0 0 0-.098.556v3.187h-1.299v-4.376Zm6.064 2.095h-.611v-1.189h.611l1.583-1.856h1.593l-2.314 2.74v-.71l2.314 3.296h-1.572l-1.604-2.281Zm-1.822-5.358h1.298v7.639h-1.298v-7.639Zm7.973 7.803c-.538 0-1.011-.117-1.419-.349a2.428 2.428 0 0 1-.927-1.005c-.219-.429-.328-.931-.328-1.506 0-.56.109-1.051.328-1.473.218-.422.523-.746.916-.971a2.66 2.66 0 0 1 1.364-.349c.808 0 1.441.243 1.899.731.466.487.699 1.149.699 1.986 0 .08-.004.167-.011.262 0 .095-.004.193-.011.295h-4.584v-1.004h3.296v-.033c0-.357-.113-.644-.338-.862-.226-.219-.542-.328-.95-.328-.276 0-.516.055-.72.164a1.144 1.144 0 0 0-.458.469 1.542 1.542 0 0 0-.153.699v.742c0 .298.055.556.164.775.109.218.269.385.48.502.211.109.466.163.764.163.269 0 .495-.054.676-.163.19-.117.332-.269.426-.459h1.332c-.11.35-.273.655-.492.917a2.164 2.164 0 0 1-.818.589 2.884 2.884 0 0 1-1.135.208Zm5.694-.164c-.32 0-.582-.044-.786-.131a.91.91 0 0 1-.436-.436c-.095-.197-.142-.459-.142-.786v-5.533h1.299v5.238c0 .175.04.302.12.382.08.08.207.12.382.12h1.124v1.146h-1.561Zm-2.728-5.326h4.289v1.146h-4.289v-1.146Zm7.672 5.49a2.94 2.94 0 0 1-1.44-.349 2.536 2.536 0 0 1-.982-.994c-.233-.429-.35-.924-.35-1.484 0-.553.117-1.044.35-1.473.233-.429.56-.76.982-.993.422-.24.902-.36 1.44-.36.546 0 1.026.12 1.441.36.422.233.749.564.982.993.24.422.36.913.36 1.473 0 .553-.12 1.044-.36 1.473-.233.43-.56.764-.982 1.005-.415.232-.895.349-1.441.349Zm0-1.179c.284 0 .535-.069.753-.207.219-.138.386-.331.503-.579a1.91 1.91 0 0 0 .185-.862c0-.327-.062-.615-.185-.862a1.345 1.345 0 0 0-.503-.578 1.37 1.37 0 0 0-.753-.208c-.276 0-.523.069-.742.208a1.422 1.422 0 0 0-.513.578 2.01 2.01 0 0 0-.174.862c0 .328.058.615.174.862a1.362 1.362 0 0 0 1.255.786Z"
          />
          <path
            stroke="#E9EBED"
            strokeWidth={0.922}
            d="M947.504 174.222v20.746"
          />
          <path
            fill="#1C2938"
            d="M953.986 181.456h1.877l2.27 6.384h-.371l2.281-6.384h1.877v7.639h-1.31v-6.428l.229.022-2.292 6.406h-1.2l-2.281-6.406.218-.022v6.428h-1.298v-7.639Zm11.245 7.803c-.408 0-.764-.069-1.07-.208a1.655 1.655 0 0 1-.709-.578 1.648 1.648 0 0 1-.24-.895c0-.335.073-.626.218-.873.146-.255.364-.455.655-.6.291-.153.648-.244 1.07-.273l1.877-.109v.971l-1.681.142a1.032 1.032 0 0 0-.469.12.728.728 0 0 0-.284.251.615.615 0 0 0-.087.327.63.63 0 0 0 .098.35.655.655 0 0 0 .305.229c.139.051.302.076.492.076.24 0 .451-.043.633-.131a.952.952 0 0 0 .436-.393c.109-.182.164-.396.164-.644v-1.538a.941.941 0 0 0-.098-.459.62.62 0 0 0-.295-.262 1.28 1.28 0 0 0-.513-.087c-.211 0-.382.022-.513.066a.558.558 0 0 0-.306.196.78.78 0 0 0-.152.349h-1.288c.036-.371.145-.68.327-.927.182-.248.44-.433.775-.557.335-.131.75-.196 1.244-.196.43 0 .797.072 1.102.218.306.138.539.342.699.611.167.269.251.593.251.971v2.478c0 .051.015.091.044.12a.162.162 0 0 0 .12.043h.469v1.048h-.982a.787.787 0 0 1-.328-.065.497.497 0 0 1-.207-.197.668.668 0 0 1-.066-.305v-.764l.197.141c-.022.27-.116.506-.284.71a1.679 1.679 0 0 1-.666.48 2.538 2.538 0 0 1-.938.164Zm4.3-4.54v-.95h1.146v1.354h-.043c0-.284.047-.524.142-.721.094-.203.236-.36.425-.469.189-.109.419-.164.688-.164h.982v1.146h-1.124c-.211 0-.386.037-.524.109a.686.686 0 0 0-.295.328 1.368 1.368 0 0 0-.098.556v3.187h-1.299v-4.376Zm6.065 2.095h-.611v-1.189h.611l1.582-1.856h1.593l-2.313 2.74v-.71l2.313 3.296H977.2l-1.604-2.281Zm-1.823-5.358h1.299v7.639h-1.299v-7.639Zm7.973 7.803c-.538 0-1.011-.117-1.418-.349a2.43 2.43 0 0 1-.928-1.005c-.218-.429-.327-.931-.327-1.506 0-.56.109-1.051.327-1.473.218-.422.524-.746.917-.971a2.66 2.66 0 0 1 1.364-.349c.808 0 1.441.243 1.899.731.466.487.698 1.149.698 1.986 0 .08-.003.167-.011.262 0 .095-.003.193-.01.295h-4.584v-1.004h3.296v-.033c0-.357-.113-.644-.339-.862-.225-.219-.542-.328-.949-.328-.276 0-.517.055-.72.164a1.14 1.14 0 0 0-.459.469 1.555 1.555 0 0 0-.152.699v.742c0 .298.054.556.163.775.109.218.269.385.48.502.211.109.466.163.764.163.27 0 .495-.054.677-.163.189-.117.331-.269.426-.459h1.331c-.109.35-.273.655-.491.917a2.16 2.16 0 0 1-.819.589 2.88 2.88 0 0 1-1.135.208Zm5.695-.164c-.321 0-.582-.044-.786-.131a.912.912 0 0 1-.437-.436c-.094-.197-.142-.459-.142-.786v-5.533h1.299v5.238c0 .175.04.302.12.382.08.08.208.12.382.12h1.124v1.146h-1.56Zm-2.729-5.326h4.289v1.146h-4.289v-1.146Zm7.673 5.49a2.944 2.944 0 0 1-1.441-.349 2.536 2.536 0 0 1-.982-.994c-.233-.429-.349-.924-.349-1.484 0-.553.116-1.044.349-1.473.233-.429.56-.76.982-.993.422-.24.903-.36 1.441-.36.546 0 1.026.12 1.441.36.422.233.749.564.982.993.24.422.36.913.36 1.473 0 .553-.12 1.044-.36 1.473-.233.43-.56.764-.982 1.005-.415.232-.895.349-1.441.349Zm0-1.179c.284 0 .535-.069.753-.207a1.34 1.34 0 0 0 .502-.579c.124-.247.186-.534.186-.862a1.9 1.9 0 0 0-.186-.862 1.343 1.343 0 0 0-.502-.578 1.37 1.37 0 0 0-.753-.208c-.276 0-.524.069-.742.208a1.422 1.422 0 0 0-.513.578 2.01 2.01 0 0 0-.175.862c0 .328.059.615.175.862a1.36 1.36 0 0 0 1.255.786Zm6.938-6.624h1.347v7.639h-1.347v-7.639Zm1.027 6.384h3.81v1.255h-3.81v-1.255Zm6.91 1.419c-.54 0-1.01-.117-1.42-.349-.4-.241-.71-.575-.93-1.005-.21-.429-.32-.931-.32-1.506 0-.56.11-1.051.32-1.473.22-.422.53-.746.92-.971.4-.233.86-.349 1.37-.349.8 0 1.44.243 1.89.731.47.487.7 1.149.7 1.986 0 .08 0 .167-.01.262 0 .095 0 .193-.01.295h-4.58v-1.004h3.29v-.033c0-.357-.11-.644-.34-.862-.22-.219-.54-.328-.94-.328-.28 0-.52.055-.73.164a1.17 1.17 0 0 0-.45.469c-.11.204-.16.437-.16.699v.742c0 .298.06.556.17.775.11.218.27.385.48.502.21.109.46.163.76.163.27 0 .5-.054.68-.163.19-.117.33-.269.42-.459h1.34c-.11.35-.28.655-.5.917-.21.255-.49.451-.81.589-.33.139-.71.208-1.14.208Zm5.31 0c-.41 0-.76-.069-1.07-.208-.3-.138-.54-.331-.71-.578a1.648 1.648 0 0 1-.24-.895c0-.335.08-.626.22-.873.15-.255.36-.455.66-.6.29-.153.64-.244 1.07-.273l1.87-.109v.971l-1.68.142a1.04 1.04 0 0 0-.47.12.709.709 0 0 0-.28.251.6.6 0 0 0-.09.327.6.6 0 0 0 .1.35c.07.102.17.178.31.229.13.051.3.076.49.076.24 0 .45-.043.63-.131a.998.998 0 0 0 .44-.393c.11-.182.16-.396.16-.644v-1.538c0-.189-.03-.342-.1-.459a.587.587 0 0 0-.29-.262 1.317 1.317 0 0 0-.52-.087c-.21 0-.38.022-.51.066a.535.535 0 0 0-.3.196.716.716 0 0 0-.16.349h-1.29c.04-.371.15-.68.33-.927.18-.248.44-.433.78-.557.33-.131.75-.196 1.24-.196.43 0 .8.072 1.1.218.31.138.54.342.7.611.17.269.25.593.25.971v2.478c0 .051.02.091.05.12.03.029.07.043.12.043h.47v1.048h-.99a.746.746 0 0 1-.32-.065.482.482 0 0 1-.21-.197.725.725 0 0 1-.07-.305v-.764l.2.141c-.02.27-.12.506-.28.71-.17.204-.39.364-.67.48a2.56 2.56 0 0 1-.94.164Zm6.52 0c-.5 0-.95-.117-1.34-.349a2.399 2.399 0 0 1-.9-.994 3.337 3.337 0 0 1-.32-1.484c0-.56.11-1.051.32-1.473.21-.429.51-.76.9-.993.39-.24.84-.36 1.34-.36.28 0 .55.043.79.131.25.08.46.203.63.371.17.16.29.352.37.578l-.2.262v-3.492h1.3v7.639h-1.15v-1.222l.18.24c-.08.233-.22.436-.41.611-.18.167-.4.298-.66.393a2.51 2.51 0 0 1-.85.142Zm.21-1.179c.27 0 .52-.069.73-.207.21-.138.37-.331.49-.579.12-.247.18-.534.18-.862 0-.327-.06-.615-.18-.862a1.4 1.4 0 0 0-.49-.578 1.307 1.307 0 0 0-.73-.208c-.29 0-.54.069-.76.208a1.4 1.4 0 0 0-.49.578c-.12.247-.17.535-.17.862 0 .328.05.615.17.862.12.248.28.441.49.579.22.138.47.207.76.207Z"
          />
          <rect
            width={23.824}
            height={21.075}
            x={1032.29}
            y={174.057}
            fill="#E9EBED"
            rx={10.538}
          />
          <path
            fill="#1C2938"
            d="M1039.78 184.921v-1.008h1.99v-2.046h1.05v2.046h1.99v1.008h-1.99v2.046h-1.05v-2.046h-1.99Zm7.07 2.802v-4.818h-1.56v-.907c1.04-.04 1.62-.45 1.75-1.23h1.2v6.955h-1.39Z"
          />
        </g>
      </g>
      <g filter="url(#aj)">
        <path fill="#fff" d="M637.66 212.984h438.994v56.778H637.66z" />
        <g clipPath="url(#ak)">
          <rect
            width={172.405}
            height={31.155}
            x={646.583}
            y={225.796}
            fill="#F9F9F9"
            rx={3.688}
          />
          <path
            stroke="#E9EBED"
            strokeWidth={0.922}
            d="M732.784 225.796v31.155"
          />
          <rect
            width={172.405}
            height={31.155}
            x={822.706}
            y={225.796}
            fill="#F9F9F9"
            rx={3.688}
          />
          <path
            stroke="#E9EBED"
            strokeWidth={0.922}
            d="M908.907 225.796v31.155"
          />
        </g>
      </g>
      <g filter="url(#al)">
        <path fill="#fff" d="M637.66 269.762h438.994v56.778H637.66z" />
        <g clipPath="url(#am)">
          <rect
            width={172.405}
            height={31.155}
            x={646.583}
            y={282.574}
            fill="#F9F9F9"
            rx={3.688}
          />
          <path
            stroke="#E9EBED"
            strokeWidth={0.922}
            d="M732.784 282.574v31.155"
          />
          <rect
            width={172.405}
            height={31.155}
            x={822.706}
            y={282.574}
            fill="#F9F9F9"
            rx={3.688}
          />
          <path
            stroke="#E9EBED"
            strokeWidth={0.922}
            d="M908.907 282.574v31.155"
          />
        </g>
      </g>
      <g filter="url(#an)">
        <path fill="#fff" d="M637.66 326.541h438.994v56.778H637.66z" />
        <g clipPath="url(#ao)">
          <rect
            width={172.405}
            height={31.155}
            x={646.583}
            y={339.352}
            fill="#F9F9F9"
            rx={3.688}
          />
          <path
            stroke="#E9EBED"
            strokeWidth={0.922}
            d="M732.784 339.352v31.155"
          />
          <rect
            width={172.405}
            height={31.155}
            x={822.706}
            y={339.352}
            fill="#F9F9F9"
            rx={3.688}
          />
          <path
            stroke="#E9EBED"
            strokeWidth={0.922}
            d="M908.907 339.352v31.155"
          />
        </g>
      </g>
      <g filter="url(#ap)">
        <path fill="#fff" d="M637.66 383.319h438.994v56.778H637.66z" />
        <g clipPath="url(#aq)">
          <rect
            width={172.405}
            height={31.155}
            x={646.583}
            y={396.13}
            fill="#F9F9F9"
            rx={3.688}
          />
          <path
            stroke="#E9EBED"
            strokeWidth={0.922}
            d="M732.784 396.13v31.155"
          />
          <rect
            width={172.405}
            height={31.155}
            x={822.706}
            y={396.13}
            fill="#F9F9F9"
            rx={3.688}
          />
          <path
            stroke="#E9EBED"
            strokeWidth={0.922}
            d="M908.907 396.13v31.155"
          />
        </g>
      </g>
    </g>
    <rect
      width={23.051}
      height={23.051}
      x={18.634}
      y={458.314}
      stroke="#E9EBED"
      strokeWidth={0.744}
      rx={3.346}
    />
    <path
      stroke="#E9EBED"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.115}
      d="m30.902 466.865-2.974 2.975 2.974 2.974"
    />
    <rect
      width={23.051}
      height={23.051}
      x={48.377}
      y={458.314}
      stroke="#DDDDE0"
      strokeWidth={0.744}
      rx={3.346}
    />
    <path
      fill="#535F6E"
      d="M59.297 473.34v-4.976h-1.614v-.937c1.069-.042 1.67-.465 1.801-1.27h1.239v7.183h-1.426Z"
    />
    <rect
      width={23.051}
      height={23.051}
      x={78.12}
      y={458.314}
      stroke="#E9EBED"
      strokeWidth={0.744}
      rx={3.346}
    />
    <rect
      width={23.051}
      height={23.051}
      x={107.863}
      y={458.314}
      stroke="#E9EBED"
      strokeWidth={0.744}
      rx={3.346}
    />
    <rect
      width={23.051}
      height={23.051}
      x={137.606}
      y={458.314}
      stroke="#E9EBED"
      strokeWidth={0.744}
      rx={3.346}
    />
    <rect
      width={23.051}
      height={23.051}
      x={167.349}
      y={458.314}
      stroke="#E9EBED"
      strokeWidth={0.744}
      rx={3.346}
    />
    <path
      stroke="#BABDC1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.115}
      d="M213.452 469.84a.372.372 0 1 1-.744 0 .372.372 0 0 1 .744 0M208.989 469.84a.373.373 0 1 1-.745-.001.373.373 0 0 1 .745.001M204.526 469.84a.373.373 0 1 1-.745-.001.373.373 0 0 1 .745.001"
    />
    <rect
      width={23.051}
      height={23.051}
      x={226.835}
      y={458.314}
      stroke="#E9EBED"
      strokeWidth={0.744}
      rx={3.346}
    />
    <rect
      width={23.051}
      height={23.051}
      x={256.578}
      y={458.314}
      stroke="#E9EBED"
      strokeWidth={0.744}
      rx={3.346}
    />
    <path
      stroke="#535F6E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.115}
      d="m267.359 472.814 2.975-2.974-2.975-2.975"
    />
    <defs>
      <filter
        id="b"
        width={23.794}
        height={41.64}
        x={18.262}
        y={57.428}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="d"
        width={23.794}
        height={56.838}
        x={18.262}
        y={99.068}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="f"
        width={23.794}
        height={56.838}
        x={18.262}
        y={155.906}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="h"
        width={23.794}
        height={56.838}
        x={18.262}
        y={212.744}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="j"
        width={23.794}
        height={56.838}
        x={18.262}
        y={269.582}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="l"
        width={23.794}
        height={56.838}
        x={18.262}
        y={326.421}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="n"
        width={23.794}
        height={56.838}
        x={18.262}
        y={383.259}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="p"
        width={171.022}
        height={41.64}
        x={42.056}
        y={57.428}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="q"
        width={171.022}
        height={60.973}
        x={42.056}
        y={97}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="s"
        width={171.022}
        height={60.973}
        x={42.056}
        y={153.839}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="v"
        width={171.022}
        height={60.973}
        x={42.056}
        y={210.677}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="x"
        width={171.022}
        height={60.973}
        x={42.056}
        y={267.515}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="z"
        width={171.022}
        height={60.973}
        x={42.056}
        y={324.353}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="B"
        width={171.022}
        height={60.973}
        x={42.056}
        y={381.191}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="D"
        width={171.022}
        height={41.64}
        x={213.078}
        y={57.428}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="E"
        width={171.022}
        height={60.973}
        x={213.078}
        y={97}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="H"
        width={171.022}
        height={60.973}
        x={213.078}
        y={153.839}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="K"
        width={171.022}
        height={60.973}
        x={213.078}
        y={210.677}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="N"
        width={171.022}
        height={60.973}
        x={213.078}
        y={267.515}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="Q"
        width={171.022}
        height={60.973}
        x={213.078}
        y={324.353}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="T"
        width={171.022}
        height={60.973}
        x={213.078}
        y={381.191}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="W"
        width={253.559}
        height={41.64}
        x={384.101}
        y={57.428}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="X"
        width={253.559}
        height={56.838}
        x={384.101}
        y={99.068}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="Y"
        width={253.559}
        height={56.838}
        x={384.101}
        y={155.906}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="aa"
        width={253.559}
        height={56.838}
        x={384.101}
        y={212.744}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="ab"
        width={253.559}
        height={56.838}
        x={384.101}
        y={269.582}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="ac"
        width={253.559}
        height={56.838}
        x={384.101}
        y={326.421}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="ad"
        width={253.559}
        height={56.838}
        x={384.101}
        y={383.259}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="ae"
        width={439}
        height={42}
        x={637.66}
        y={57.428}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="af"
        width={438.994}
        height={60.973}
        x={637.66}
        y={97.33}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="ah"
        width={438.994}
        height={60.973}
        x={637.66}
        y={154.108}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="aj"
        width={438.994}
        height={60.973}
        x={637.66}
        y={210.887}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="al"
        width={438.994}
        height={60.973}
        x={637.66}
        y={267.665}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="an"
        width={438.994}
        height={60.973}
        x={637.66}
        y={324.443}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <filter
        id="ap"
        width={438.994}
        height={60.973}
        x={637.66}
        y={381.221}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={-0.744} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.913725 0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_11_3332" />
      </filter>
      <clipPath id="a">
        <path fill="#fff" d="M18.262 57.428h1058.39v382.669H18.262z" />
      </clipPath>
      <clipPath id="c">
        <path fill="#fff" d="M30.159 72.3h11.897v11.896H30.159z" />
      </clipPath>
      <clipPath id="e">
        <path fill="#fff" d="M30.159 121.538h11.897v11.897H30.159z" />
      </clipPath>
      <clipPath id="g">
        <path fill="#fff" d="M30.159 178.377h11.897v11.897H30.159z" />
      </clipPath>
      <clipPath id="i">
        <path fill="#fff" d="M30.159 235.215h11.897v11.897H30.159z" />
      </clipPath>
      <clipPath id="k">
        <path fill="#fff" d="M30.159 292.053h11.897v11.897H30.159z" />
      </clipPath>
      <clipPath id="m">
        <path fill="#fff" d="M30.159 348.891h11.897v11.897H30.159z" />
      </clipPath>
      <clipPath id="o">
        <path fill="#fff" d="M30.159 405.729h11.897v11.897H30.159z" />
      </clipPath>
      <clipPath id="r">
        <path fill="#fff" d="M50.98 97h153.175v60.973H50.98z" />
      </clipPath>
      <clipPath id="t">
        <path fill="#fff" d="M50.98 153.839h153.175v60.973H50.98z" />
      </clipPath>
      <clipPath id="u">
        <rect
          width={92.923}
          height={17.846}
          x={50.979}
          y={175.402}
          fill="#fff"
          rx={2.974}
        />
      </clipPath>
      <clipPath id="w">
        <path fill="#fff" d="M50.98 210.677h153.175v60.973H50.98z" />
      </clipPath>
      <clipPath id="y">
        <path fill="#fff" d="M50.98 267.515h153.175v60.973H50.98z" />
      </clipPath>
      <clipPath id="A">
        <path fill="#fff" d="M50.98 324.353h153.175v60.973H50.98z" />
      </clipPath>
      <clipPath id="C">
        <path fill="#fff" d="M50.98 381.191h153.175v60.973H50.98z" />
      </clipPath>
      <clipPath id="F">
        <path fill="#fff" d="M222.001 97h153.176v60.973H222.001z" />
      </clipPath>
      <clipPath id="G">
        <rect
          width={78.819}
          height={21.83}
          x={222.001}
          y={116.572}
          fill="#fff"
          rx={2.974}
        />
      </clipPath>
      <clipPath id="I">
        <path fill="#fff" d="M222.001 153.839h153.176v60.973H222.001z" />
      </clipPath>
      <clipPath id="J">
        <rect
          width={141.846}
          height={21.83}
          x={222.001}
          y={173.41}
          fill="#fff"
          rx={2.974}
        />
      </clipPath>
      <clipPath id="L">
        <path fill="#fff" d="M222.001 210.677h153.176v60.973H222.001z" />
      </clipPath>
      <clipPath id="M">
        <rect
          width={78.819}
          height={21.83}
          x={222.001}
          y={230.248}
          fill="#fff"
          rx={2.974}
        />
      </clipPath>
      <clipPath id="O">
        <path fill="#fff" d="M222.001 267.515h153.176v60.973H222.001z" />
      </clipPath>
      <clipPath id="P">
        <rect
          width={78.819}
          height={21.83}
          x={222.001}
          y={287.086}
          fill="#fff"
          rx={2.974}
        />
      </clipPath>
      <clipPath id="R">
        <path fill="#fff" d="M222.001 324.353h153.176v60.973H222.001z" />
      </clipPath>
      <clipPath id="S">
        <rect
          width={78.819}
          height={21.83}
          x={222.001}
          y={343.925}
          fill="#fff"
          rx={2.974}
        />
      </clipPath>
      <clipPath id="U">
        <path fill="#fff" d="M222.001 381.191h153.176v60.973H222.001z" />
      </clipPath>
      <clipPath id="V">
        <rect
          width={78.819}
          height={21.83}
          x={222.001}
          y={400.763}
          fill="#fff"
          rx={2.974}
        />
      </clipPath>
      <clipPath id="ag">
        <path fill="#fff" d="M646.583 97.33h421.148v60.973H646.583z" />
      </clipPath>
      <clipPath id="ai">
        <path fill="#fff" d="M646.583 154.108h421.148v60.973H646.583z" />
      </clipPath>
      <clipPath id="ak">
        <path fill="#fff" d="M646.583 210.887h421.148v60.973H646.583z" />
      </clipPath>
      <clipPath id="am">
        <path fill="#fff" d="M646.583 267.665h421.148v60.973H646.583z" />
      </clipPath>
      <clipPath id="ao">
        <path fill="#fff" d="M646.583 324.443h421.148v60.973H646.583z" />
      </clipPath>
      <clipPath id="aq">
        <path fill="#fff" d="M646.583 381.221h421.148v60.973H646.583z" />
      </clipPath>
      <linearGradient
        id="Z"
        x1={496.975}
        x2={496.975}
        y1={180.686}
        y2={187.964}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00AEEF" />
        <stop offset={0.212} stopColor="#0097DC" />
        <stop offset={0.519} stopColor="#007CC5" />
        <stop offset={0.792} stopColor="#006CB8" />
        <stop offset={1} stopColor="#0066B3" />
      </linearGradient>
    </defs>
  </svg>
);
export default DashboardUI;
